<template>
    <div>
        <v-container fluid grid-list-xl class="general-container scoring-page-container">
            <v-layout row wrap class="navigation-header">
                <v-flex xs12>
                    <header-bar-medical-device :title="text('api.scoring.title')"></header-bar-medical-device>
                </v-flex>
            </v-layout>

            <v-layout row wrap class="scoring-page-content page-content padding-left-xxl padding-right-xxl">
                <v-flex xl10 md8 sm6 xs12 align-start>
                </v-flex>

            </v-layout>

            <div class="scrolling-content-scoring scrolling-content-scoring-ie" ref="vLayoutScrollableRef">
                <v-layout row wrap class="layout-scoring-page">
                    <v-flex xs12 style="padding-top: 2px;">
                        <div v-if="scoringData.hasScoringData === false">
                            <div
                                id="PANEL_NO_RECOMMENDATION"
                                ref="NO_RECOMMENDATION"
                                class="font-size-medium no-recommendation expansion-list"
                                :class="{'border-highlighted': shortcutNav.isPanelHighlight === true && shortcutNav.crtPanel === 'NO_RECOMMENDATION'}"
                                :style="shortcutNav.isPanelHighlight === true && shortcutNav.crtPanel === 'NO_RECOMMENDATION' ? {'border-color': getCurrentGuiThemeColor + ' !important'} : ''">
                                <p v-if="!getAppPropertyStudyAccess" class="no-margin-bottom">{{ text("api.evaluation.noDecision") }}</p>
                                <!--- WARNING SECTION------->
                                <!--- texts should be change with DB values--->

                                <div
                                    v-if="scoringData.noOtherSymptomsWarning || scoringData.highlightedQuestionsAllAnsweredWarning || scoringData.shortcutUsedWarning"
                                    class="warning-symptoms warning-section margin-top-s margin-bottom-s">
                                    <div class="warning-wrapper">
                                        <WarningIcon></WarningIcon>
                                        <span>
                                        {{ text('db.product.PROD_PROPERTY_EVALUATION_WARNING_TITLE') }}
                                    </span>
                                    </div>
                                    <span>{{ text('db.product.PROD_PROPERTY_EVALUATION_WARNING_DESCRIPTION') }}</span>
                                    <ul class="warning-list">
                                        <li style="margin-left: 21px" v-if="scoringData.noOtherSymptomsWarning">
                                            {{ text('db.product.PROD_PROPERTY_NO_OTHER_SYMPTOMS_WARNING') }}
                                        </li>

                                        <li style="margin-left: 21px"
                                            v-if="scoringData.highlightedQuestionsAllAnsweredWarning">
                                            {{ text('db.product.PROD_PROPERTY_HIGHLIGHTED_QUESTIONS_ALL_ANSWERED_WARNING') }}
                                        </li>

                                        <li style="margin-left: 21px" v-if="scoringData.shortcutUsedWarning">
                                            {{ text('db.product.PROD_PROPERTY_SHORTCUT_USED_WARNING') }}
                                        </li>
                                    </ul>
                                </div>
                                <div v-if="scoringData.notes !== null && scoringData.notes.length > 0">
                                    <h4 class="headline-decision-h3">{{ text('api.assessment.headline.notes') }}</h4>
                                    <div v-for="note in scoringData.notes">
                                        <table class="note-table" role="presentation">
                                            <tr>
                                                <td>
                                                    <h4 v-if="note.text"
                                                        v-html="note.text"
                                                        class="decision-headline di-headline">
                                                    </h4>
                                                    <p class="decision-text note-text"
                                                       v-if="note.description"
                                                       v-html="note.description">
                                                    </p>
                                                </td>
                                            </tr>
                                        </table>
                                    </div>
                                </div>



                            </div>

                            <div
                                v-if="scoringData.displayedCodeSystems !== null && Object.keys(scoringData.displayedCodeSystems).length > 0"
                                class="measures-panel">
                                <v-expansion-panel expand>
                                    <v-expansion-panel-content class="expansion-list recommendations-container"
                                                               :class="{'border-highlighted': shortcutNav.isPanelHighlight === true && shortcutNav.crtPanel === 'MEASURES'}"
                                                               id="PANEL_MEASURESs"
                                                               ref="MEASURES"
                                                               :value="navManageClosedPanel('MEASURES')"
                                    >

                                        <div slot="header" class="font-size-medium">
                                            {{ text('db.product.PROD_TITLE_ADV') }}
                                        </div>
                                        <div
                                            slot="actions"
                                            class="svg-wrapper"
                                            :style="{
                                                    'width': 30 + 'px',
                                                    'height': 30 + 'px'
                                            }"
                                        >
                                            <ExpandIcon v-if="getIsPanelActive('MEASURES') === false" :width="30"
                                                        :height="30"/>
                                            <CollapseIcon v-else :width="30" :height="30"/>
                                        </div>
                                        <v-card>
                                            <v-card-text>
                                                <div
                                                    v-if="getAppPropertyValue('CODING_SYSTEM_WARNING_DISPLAY') === 'true'"
                                                    class="diagnosis-warning">
                                                    <div class="diagnosis-warning-title">
                                                        <WarningIcon></WarningIcon>
                                                        <span>{{ text("api.summary.communication.codeSystem.warning.label") }}</span>
                                                    </div>
                                                    <div class="diagnosis-warning-description">
                                                        <p>
                                                            {{ text("api.summary.communication.codeSystem.warning.description") }}
                                                        </p>
                                                    </div>
                                                </div>

                                                <div v-if="Object.keys(scoringData.displayedCodeSystems).length > 0">
                                                    <div>
                                                        <div
                                                            v-for="(codeSystem, key) in scoringData.displayedCodeSystems"
                                                            class="margin-bottom-s">
                                                            <h4 v-if="codeSystem.name !== 'undefined' &&
                                                                      codeSystem.name !== null &&
                                                                      codeSystem.name.length > 0">
                                                                {{ codeSystem.name }}
                                                            </h4>
                                                            <div v-for="code in codeSystem.articles"
                                                                 class="code-system code-system-block">
                                                                <ul>
                                                                    <!--display code.name if code.commonName === null -->
                                                                    <li class="common-name-code-system">
                                                                        {{ code.code }}: {{ code.name }}
                                                                    </li>
                                                                    <div class='likelihood'
                                                                         v-if="code.likelihood !== null">
                                                                        <div class='progress bg-color-primary'
                                                                             v-bind:style="{'width': code.likelihood + '%'}"></div>
                                                                    </div>
                                                                    <!--don't display code.name if code.commonName === null-->
                                                                    <p class="code-system-article-name">
                                                                        {{ code.commonName }}
                                                                    </p>
                                                                    <p class="code-system-description"
                                                                       v-html="code.commonDescription"></p>
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>

                                            </v-card-text>
                                        </v-card>
                                    </v-expansion-panel-content>
                                </v-expansion-panel>
                            </div>

                            <!-- display commentTexts if !hasScoringData -->
                            <v-expansion-panel expand>
                                <v-expansion-panel-content class="expansion-list comments-container"
                                                           :class="{'border-highlighted': shortcutNav.isPanelHighlight === true && shortcutNav.crtPanel === 'RATIONALE'}"
                                                           :value="navManageClosedPanel('RATIONALE')"
                                                           v-if="scoringData.comments && scoringData.comments.commentTexts.length > 0"
                                >
                                    <div slot="header" class="font-size-medium"
                                         v-if="scoringData.comments.commentTexts">
                                        {{ text('db.product.PROD_TITLE_RAT') }}
                                    </div>
                                    <div
                                        slot="actions"
                                        class="svg-wrapper"
                                        :style="{
                                                    'width': 30 + 'px',
                                                    'height': 30 + 'px'
                                            }"
                                    >
                                        <ExpandIcon v-if="!navIsPanelClosed('RATIONALE')" :width="30" :height="30"/>
                                        <CollapseIcon v-else :width="30" :height="30"/>
                                    </div>
                                    <v-card>
                                        <v-card-text>

                                            <div v-if="scoringData.comments.commentTexts">
                                                <p v-for="comment in scoringData.comments.commentTexts"
                                                   class="font-weight-regular no-margin-bottom" v-html="comment">
                                                </p>
                                            </div>

                                        </v-card-text>
                                    </v-card>
                                </v-expansion-panel-content>
                            </v-expansion-panel>

                        </div>


                        <v-expansion-panel expand v-else>

                            <v-expansion-panel-content
                                v-if="scoringData.decisions && scoringData.hasScoringData"
                                class="expansion-list decisions-container"
                                :class="{'border-highlighted': shortcutNav.isPanelHighlight === true && shortcutNav.crtPanel === 'RECOMMENDATIONS'}"
                                id="PANEL_RECOMMENDATIONS"
                                ref="RECOMMENDATIONS"
                                :value="navManageClosedPanel('RECOMMENDATIONS')"
                            >
                                <div slot="header" class="font-size-medium">
                                    {{ text('db.product.PROD_SCORING') }}

                                </div>
                                <div
                                    slot="actions"
                                    class="svg-wrapper"
                                    :style="{
                                                    'width': 30 + 'px',
                                                    'height': 30 + 'px'
                                            }"
                                >
                                    <ExpandIcon v-if="getIsPanelActive('RECOMMENDATIONS') === false" :width="30"
                                                :height="30"/>
                                    <CollapseIcon v-else :width="30" :height="30"/>
                                </div>
                                <v-card>
                                    <v-card-text>
                                        <div>
                                            <v-flex xs12>

                                                <v-layout>

                                                    <table class="assessment-content-table scoring-page-decisions"
                                                           role="presentation">
                                                        <tr>
                                                            <td>
                                                                <h3 class="headline-decision-h3">
                                                                    {{ text('api.assessment.headline.di1') }}</h3>
                                                                <table
                                                                    :id="((scoringData.decisions.decisionItem1.code) ? ('DI1_' + scoringData.decisions.decisionItem1.code) : null)"
                                                                    role="presentation">
                                                                    <tr>
                                                                        <td v-if="scoringData.decisions.decisionItem1.icon">
                                                                            <div
                                                                                v-html="scoringData.decisions.decisionItem1.icon.replace(/COLOR_PLACEHOLDER/gi, getDecisionItemColor(scoringData.decisions.decisionItem1))"
                                                                                :id="((scoringData.decisions.decisionItem1.code) ? ('DI1_ICON_' + scoringData.decisions.decisionItem1.code) : null)"
                                                                                class="decision-item-item-svg">
                                                                            </div>
                                                                        </td>
                                                                        <td>
                                                                            <h4 class="decision-headline"
                                                                                v-html="scoringData.decisions.decisionItem1.headline"
                                                                                :id="((scoringData.decisions.decisionItem1.code) ? ('DI1_HEADLINE_' + scoringData.decisions.decisionItem1.code) : null)"
                                                                                v-bind:style="{'color': getDecisionItemColor(scoringData.decisions.decisionItem1) }">
                                                                            </h4>
                                                                            <p :id="((scoringData.decisions.decisionItem1.code) ? ('DI1_HEADLINE_' + scoringData.decisions.decisionItem1.code) : null)"
                                                                               v-html="scoringData.decisions.decisionItem1.text"
                                                                               class="decision-text"
                                                                            ></p>

                                                                        </td>
                                                                    </tr>
                                                                </table>
                                                                <br/>

                                                                <h3 v-if="scoringData.decisions.decisionItems2 != null && scoringData.decisions.decisionItems2.length > 0"
                                                                    class="headline-decision-h3">
                                                                    {{ text('api.assessment.headline.di2') }}</h3>

                                                                <div
                                                                    v-for="decisionItem2 in scoringData.decisions.decisionItems2"

                                                                >

                                                                    <table v-if="!decisionItem2.target"
                                                                           :id="((decisionItem2.code) ? ('DI2_NO_TARGET_' + decisionItem2.code) : null)"
                                                                           role="presentation">
                                                                        <tr>

                                                                            <td>
                                                                                <h4 class="decision-headline"
                                                                                    v-html="decisionItem2.headline"
                                                                                    :id="((decisionItem2.code) ? ('DI2_HEADLINE_NO_TARGET_' + decisionItem2.code) : null)"
                                                                                    v-bind:style="{'color': getDecisionItemColor(decisionItem2) }"
                                                                                >

                                                                                </h4>
                                                                                <p :id="((decisionItem2.code) ? ('DI2_TEXT_NO_TARGET_' + decisionItem2.code) : null)"
                                                                                   v-html="decisionItem2.text"
                                                                                   class="decision-text"
                                                                                >
                                                                                </p>
                                                                            </td>
                                                                        </tr>

                                                                    </table>

                                                                    <table v-else
                                                                           :id="((decisionItem2.code) ? ('DI2_' + decisionItem2.code) : null)"
                                                                           role="presentation">
                                                                        <tr>
                                                                            <td>
                                                                                <WarningIcon
                                                                                    class="ambulance-scoring scoring-page">
                                                                                </WarningIcon>
                                                                            </td>
                                                                            <td>
                                                                                <h4 :id="((decisionItem2.code) ? ('DI2_HEADLINE_' + decisionItem2.code) : null)"
                                                                                    v-html="decisionItem2.headline"
                                                                                    class="decision-headline"
                                                                                    v-bind:style="{'color': getDecisionItemColor(decisionItem2) }"
                                                                                >

                                                                                </h4>
                                                                                <p :id="((decisionItem2.code) ? ('DI2_TEXT_' + decisionItem2.code) : null)"
                                                                                   v-html="decisionItem2.text"
                                                                                   class="decision-text"
                                                                                >
                                                                                </p>
                                                                            </td>
                                                                        </tr>

                                                                    </table>

                                                                </div>


                                                                <br/>

                                                                <div
                                                                    v-if="scoringData.decisions.decisionItems3 && scoringData.decisions.decisionItems3.length > 0">
                                                                    <h3 class="headline-decision-h3">
                                                                        {{ text('api.assessment.headline.di3') }}</h3>
                                                                    <div
                                                                        v-if="scoringData.decisions.decisionItems3Recommended && scoringData.decisions.decisionItems3Recommended.length > 0"
                                                                        class="decision-item-header">
                                                                        {{
                                                                            text('api.assessment.headline.di3.recommended')
                                                                        }}
                                                                    </div>
                                                                    <div
                                                                        v-for="decisionItem3 in scoringData.decisions.decisionItems3Recommended"
                                                                        :id="((decisionItem3.code) ? ('DI3_REC_' + decisionItem3.code) : null)"
                                                                        class="padding-left-s"
                                                                    >
                                                                        <table role="presentation">
                                                                            <tr>
                                                                                <td v-if="decisionItem3.icon">
                                                                                    <div
                                                                                        :id="((decisionItem3.code) ? ('DI3_REC_ICON_' + decisionItem3.code) : null)"
                                                                                        v-html="decisionItem3.icon"
                                                                                        class="decision-item-item-svg"
                                                                                    ></div>
                                                                                </td>

                                                                                <td>
                                                                                    <h4 v-bind:style="{'color': getDecisionItemColor(decisionItem3) }"
                                                                                        :id="((decisionItem3.code) ? ('DI3_REC_HEADLINE_' + decisionItem3.code) : null)"
                                                                                        v-html="decisionItem3.headline"
                                                                                        class="di-headline decision-headline"
                                                                                    ></h4>
                                                                                    <p v-if="decisionItem3.text"
                                                                                       :id="((decisionItem3.code) ? ('DI3_REC_TEXT_' + decisionItem3.code) : null)"
                                                                                       v-html="decisionItem3.text"
                                                                                       class="decision-text"
                                                                                    ></p>
                                                                                </td>

                                                                            </tr>
                                                                        </table>
                                                                    </div>

                                                                    <div
                                                                        v-if="scoringData.decisions.decisionItems3Possible && scoringData.decisions.decisionItems3Possible.length > 0"
                                                                        class="decision-item-header">
                                                                        {{
                                                                            text('api.assessment.headline.di3.possible')
                                                                        }}
                                                                    </div>
                                                                    <div
                                                                        v-for="decisionItem3 in scoringData.decisions.decisionItems3Possible"
                                                                        :id="((decisionItem3.code) ? ('DI3_POS_' + decisionItem3.code) : null)"
                                                                        class="padding-left-s"
                                                                    >
                                                                        <table role="presentation">
                                                                            <tr>
                                                                                <td v-if="decisionItem3.icon">
                                                                                    <div
                                                                                        :id="((decisionItem3.code) ? ('DI3_POS_ICON_' + decisionItem3.code) : null)"
                                                                                        v-html="decisionItem3.icon"
                                                                                        class="decision-item-item-svg">
                                                                                    </div>
                                                                                </td>

                                                                                <td>
                                                                                    <h4 :id="((decisionItem3.code) ? ('DI3_POS_HEADLINE_' + decisionItem3.code) : null)"
                                                                                        v-html="decisionItem3.headline"
                                                                                        class="di-headline decision-headline"
                                                                                        v-bind:style="{'color': getDecisionItemColor(decisionItem3) }"
                                                                                    ></h4>
                                                                                    <p v-if="decisionItem3.text"
                                                                                       :id="((decisionItem3.code) ? ('DI3_POS_TEXT_' + decisionItem3.code) : null)"
                                                                                       v-html="decisionItem3.text"
                                                                                       class="decision-text"
                                                                                    ></p>
                                                                                </td>

                                                                            </tr>
                                                                        </table>
                                                                    </div>
                                                                    <br/>
                                                                </div>


                                                                <div
                                                                    v-if="scoringData.decisions.decisionItems4 && scoringData.decisions.decisionItems4.length > 0">
                                                                    <h3 class="headline-decision-h3">
                                                                        {{ text('api.assessment.headline.di4') }}</h3>
                                                                    <div
                                                                        v-if="scoringData.decisions.decisionItems4Recommended && scoringData.decisions.decisionItems4Recommended.length > 0"
                                                                        class="decision-item-header">
                                                                        {{
                                                                            text('api.assessment.headline.di4.recommended')
                                                                        }}
                                                                    </div>
                                                                    <div
                                                                        v-for="decisionItem4 in scoringData.decisions.decisionItems4Recommended"
                                                                        :id="((decisionItem4.code) ? ('DI4_REC_' + decisionItem4.code) : null)"
                                                                        class="padding-left-s"
                                                                    >
                                                                        <table role="presentation">
                                                                            <tr>
                                                                                <td v-if="decisionItem4.icon">
                                                                                    <div
                                                                                        :id="((decisionItem4.code) ? ('DI4_REC_ICON_' + decisionItem4.code) : null)"
                                                                                        v-html="decisionItem4.icon"
                                                                                        class="decision-item-item-svg">
                                                                                    </div>
                                                                                </td>

                                                                                <td>
                                                                                    <h4 :id="((decisionItem4.code) ? ('DI4_REC_HEADLINE_' + decisionItem4.code) : null)"
                                                                                        v-html="decisionItem4.headline"
                                                                                        class="di-headline decision-headline"
                                                                                        v-bind:style="{'color': getDecisionItemColor(decisionItem4)}"
                                                                                    ></h4>
                                                                                    <p v-if="decisionItem4.text"
                                                                                       :id="((decisionItem4.code) ? ('DI4_REC_TEXT_' + decisionItem4.code) : null)"
                                                                                       v-html="decisionItem4.text"
                                                                                       class="decision-text"
                                                                                    ></p>
                                                                                </td>

                                                                            </tr>
                                                                        </table>
                                                                    </div>

                                                                    <div
                                                                        v-if="scoringData.decisions.decisionItems4Possible && scoringData.decisions.decisionItems4Possible.length > 0"
                                                                        class="decision-item-header">
                                                                        {{
                                                                            text('api.assessment.headline.di4.possible')
                                                                        }}
                                                                    </div>
                                                                    <div
                                                                        v-for="decisionItem4 in scoringData.decisions.decisionItems4Possible"
                                                                        :id="((decisionItem4.code) ? ('DI4_POS_' + decisionItem4.code) : null)"
                                                                        class="padding-left-s"
                                                                    >
                                                                        <table role="presentation">
                                                                            <tr>
                                                                                <td v-if="decisionItem4.icon">
                                                                                    <div
                                                                                        :id="((decisionItem4.code) ? ('DI4_POS_ICON_' + decisionItem4.code) : null)"
                                                                                        v-html="decisionItem4.icon"
                                                                                        class="decision-item-item-svg"
                                                                                    ></div>
                                                                                </td>

                                                                                <td>
                                                                                    <h4 :id="((decisionItem4.code) ? ('DI4_POS_HEADLINE_' + decisionItem4.code) : null)"
                                                                                        v-html="decisionItem4.headline"
                                                                                        class="di-headline decision-headline"
                                                                                        v-bind:style="{'color': getDecisionItemColor(decisionItem4)}"
                                                                                    ></h4>
                                                                                    <p :id="((decisionItem4.code) ? ('DI4_POS_TEXT_' + decisionItem4.code) : null)"
                                                                                       v-if="decisionItem4.text"
                                                                                       class="decision-text"
                                                                                       v-html="decisionItem4.text"
                                                                                    ></p>
                                                                                </td>

                                                                            </tr>
                                                                        </table>
                                                                    </div>
                                                                </div>


                                                                <div
                                                                    v-if="scoringData.notes !== null && scoringData.notes.length > 0">
                                                                    <h4 class="headline-decision-h3">
                                                                        {{ text('api.assessment.headline.notes') }}</h4>
                                                                    <div v-for="note in scoringData.notes">
                                                                        <table class="note-table" role="presentation">
                                                                            <tr>
                                                                                <td>
                                                                                    <h4 v-if="note.text"
                                                                                        v-html="note.text"
                                                                                        class="decision-headline di-headline">
                                                                                    </h4>
                                                                                    <p class="decision-text note-text"
                                                                                       v-if="note.description"
                                                                                       v-html="note.description">
                                                                                    </p>
                                                                                </td>
                                                                            </tr>
                                                                        </table>
                                                                    </div>
                                                                    <br/>
                                                                </div>

                                                                <div
                                                                    v-if="getAppPropertyValue('CODING_SYSTEM_WARNING_DISPLAY') === 'true' && Object.keys(scoringData.displayedCodeSystems).length > 0"
                                                                    class="diagnosis-warning">
                                                                    <div class="diagnosis-warning-title">
                                                                        <WarningIcon></WarningIcon>
                                                                        <span>{{ text("api.summary.communication.codeSystem.warning.label") }}</span>
                                                                    </div>
                                                                    <div class="diagnosis-warning-description">
                                                                        <p>
                                                                            {{ text("api.summary.communication.codeSystem.warning.description") }}
                                                                        </p>
                                                                    </div>
                                                                </div>

                                                                <div
                                                                    v-if="Object.keys(scoringData.displayedCodeSystems).length > 0">
                                                                    <div>
                                                                        <div
                                                                            v-for="(codeSystem, key) in scoringData.displayedCodeSystems"
                                                                            :id="((codeSystem.type) ? ('CODE_SYSTEM_' + codeSystem.type) : null)"
                                                                            class="margin-bottom-s"
                                                                        >
                                                                            <h4 v-if="codeSystem.name !== 'undefined' &&
                                                                                          codeSystem.name !== null &&
                                                                                          codeSystem.name.length > 0"
                                                                                :id="((codeSystem.type) ? ('CODE_SYSTEM_NAME_' + codeSystem.type) : null)"
                                                                            >
                                                                                {{ codeSystem.name }}
                                                                            </h4>
                                                                            <div v-for="code in codeSystem.articles"
                                                                                 class="code-system code-system-block">
                                                                                <ul :id="((code.code) ? ('CODE_ARTICLE_' + code.code) : null)">
                                                                                    <!--display code.name if code.commonName === null -->
                                                                                    <li :id="((code.code) ? ('CODE_ARTICLE_NAME_' + code.code) : null)"
                                                                                        class="common-name-code-system">
                                                                                        {{ code.code }}: {{ code.name }}
                                                                                    </li>
                                                                                    <div v-if="code.likelihood !== null"
                                                                                         class='likelihood'>
                                                                                        <div
                                                                                            class='progress bg-color-primary'
                                                                                            v-bind:style="{'width': code.likelihood + '%'}"></div>
                                                                                    </div>
                                                                                    <!--don't display code.name if code.commonName === null-->
                                                                                    <p :id="((code.code) ? ('CODE_ARTICLE_COMMON_NAME_' + code.code) : null)"
                                                                                       class="code-system-article-name">
                                                                                        {{ code.commonName }}
                                                                                    </p>
                                                                                    <p :id="((code.code) ? ('CODE_ARTICLE_COMMON_DESC_' + code.code) : null)"
                                                                                       v-html="code.commonDescription"
                                                                                       class="code-system-description"
                                                                                    ></p>
                                                                                </ul>
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                </div>
                                                            </td>
                                                        </tr>
                                                    </table>

                                                </v-layout>

                                            </v-flex>
                                            <v-flex xs12 class="warning-section"
                                                    v-if="scoringData.noOtherSymptomsWarning || scoringData.highlightedQuestionsAllAnsweredWarning || scoringData.shortcutUsedWarning">
                                                <div>
                                                    <div class="warning-wrapper">
                                                        <WarningIcon></WarningIcon>
                                                        <span>{{ text('db.product.PROD_PROPERTY_EVALUATION_WARNING_TITLE') }}</span>
                                                    </div>
                                                    <span>{{ text('db.product.PROD_PROPERTY_EVALUATION_WARNING_DESCRIPTION') }}</span>
                                                    <ul>
                                                        <li v-if="scoringData.noOtherSymptomsWarning">
                                                            {{ text('db.product.PROD_PROPERTY_NO_OTHER_SYMPTOMS_WARNING') }}
                                                        </li>

                                                        <li v-if="scoringData.highlightedQuestionsAllAnsweredWarning">
                                                            {{ text('db.product.PROD_PROPERTY_HIGHLIGHTED_QUESTIONS_ALL_ANSWERED_WARNING') }}
                                                        </li>

                                                        <li v-if="scoringData.shortcutUsedWarning">
                                                            {{ text('db.product.PROD_PROPERTY_SHORTCUT_USED_WARNING') }}
                                                        </li>
                                                    </ul>
                                                </div>

                                            </v-flex>

                                        </div>
                                    </v-card-text>
                                </v-card>
                            </v-expansion-panel-content>


                            <v-expansion-panel-content
                                class="expansion-list comments-container"
                                :class="{'border-highlighted': shortcutNav.isPanelHighlight === true && shortcutNav.crtPanel === 'RATIONALE'}"
                                id="PANEL_RATIONALE"
                                ref="RATIONALE"
                                :value="navManageClosedPanel('RATIONALE')"
                                v-if="scoringData.comments && scoringData.hasScoringData && scoringData.comments.commentTexts.length > 0"
                            >
                                <div slot="header" class="font-size-medium" v-if="scoringData.comments.commentTexts">
                                    {{ text('db.product.PROD_TITLE_RAT') }}
                                </div>
                                <div
                                    slot="actions"
                                    class="svg-wrapper"
                                    :style="{
                                           'width': 30 + 'px',
                                           'height': 30 + 'px'
                                         }"
                                >

                                    <ExpandIcon v-if="getIsPanelActive('RATIONALE') === false" :width="30"
                                                :height="30"/>
                                    <CollapseIcon v-else/>
                                </div>
                                <v-card>
                                    <v-card-text>
                                        <div v-if="scoringData.comments.commentTexts">
                                            <p v-for="(comment, commentIndex) in scoringData.comments.commentTexts"
                                               :id="'COMMENTS_TEXT_' + commentIndex"
                                               class="font-weight-regular no-margin-bottom"
                                               v-html="comment"
                                            ></p>
                                        </div>

                                    </v-card-text>
                                </v-card>
                            </v-expansion-panel-content>

                            <div
                                v-if="scoringData.recommendations && scoringData.recommendations.recommendationsSections.length > 0 && scoringData.hasScoringData"
                                class="measures-panel">
                                <v-expansion-panel-content class="expansion-list recommendations-container"
                                                           :class="{'border-highlighted': shortcutNav.isPanelHighlight === true && shortcutNav.crtPanel === 'MEASURES'}"
                                                           id="PANEL_MEASURES"
                                                           ref="MEASURES"
                                                           :value="navManageClosedPanel('MEASURES')"
                                >

                                    <div slot="header" class="font-size-medium">
                                        {{ text('db.product.PROD_TITLE_ADV') }}
                                    </div>
                                    <div
                                        slot="actions"
                                        class="svg-wrapper"
                                        :style="{
                                                    'width': 30 + 'px',
                                                    'height': 30 + 'px'
                                            }"
                                    >
                                        <ExpandIcon v-if="getIsPanelActive('MEASURES') === false" :width="30"
                                                    :height="30"/>
                                        <CollapseIcon v-else :width="30" :height="30"/>
                                    </div>
                                    <v-card>
                                        <v-card-text>

                                            <div
                                                v-if="scoringData.recommendations && scoringData.recommendations.recommendationsSections.length > 0 && scoringData.hasScoringData">

                                                <div
                                                    v-for="recommendation in scoringData.recommendations.recommendationsSections"
                                                    class="padding-bottom-xs">
                                                    <h4 v-if="recommendation.title && recommendation.recommendationsTexts"
                                                        v-html="recommendation.title"></h4>

                                                    <ul v-for="recommendationItem in recommendation.recommendationsTexts"
                                                        class="font-weight-regular">
                                                        <li class="recommendationlist"
                                                            v-if="recommendationItem.type === 'LIST_ITEM'"
                                                            v-html="recommendationItem.text"></li>
                                                        <li v-else v-html="recommendationItem.text"></li>
                                                    </ul>
                                                </div>

                                            </div>

                                        </v-card-text>
                                    </v-card>
                                </v-expansion-panel-content>
                            </div>

                        </v-expansion-panel>


                        <v-expansion-panel v-if="userDecision" expand>
                            <v-expansion-panel-content class="expansion-list user-decision-container"
                                                       :class="{'border-highlighted': shortcutNav.isPanelHighlight === true && shortcutNav.crtPanel === 'MY_DECISION'}"
                                                       id="PANEL_MY_DECISION"
                                                       ref="MY_DECISION"
                                                       :value="navManageClosedPanel('MY_DECISION')"
                            >

                                <div slot="header" class=" font-size-medium">
                                    {{ text('db.product.PROD_TITLE_MY_DECISION') }}
                                </div>
                                <div
                                    slot="actions"
                                    class="svg-wrapper"
                                    :style="{
                                           'width': 30 + 'px',
                                           'height': 30 + 'px'
                                         }"
                                >
                                    <ExpandIcon v-if="getIsPanelActive('MY_DECISION') === false" :width="30"
                                                :height="30"/>
                                    <CollapseIcon v-else :width="30" :height="30"/>
                                </div>

                                <v-card>
                                    <v-card-text>
                                        <v-container fluid class="no-padding-top padding-right-xs no-padding-left"
                                                     :class="{'assessment-sealed': getIsAssessmentSealed}">
                                            <v-layout row wrap v-if="userDecision.decisionItem1List">

                                                <v-flex xs12 md4 lg3 class="margin-bottom-m decision-row">
                                                    <!-- @TODO Add translation for placeholder -->

                                                    <div class="change-true">
                                                        <v-progress-circular v-if="newDecisionItem1"
                                                                             :value="100"
                                                                             class="color-primary"
                                                                             :rotate="-90"
                                                                             :width="1"
                                                                             :size="26"
                                                                             color="primary">
                                                            <radial-progress-svg
                                                                class="margin-top-xxs">
                                                            </radial-progress-svg>
                                                        </v-progress-circular>
                                                    </div>


                                                    <v-select
                                                        ref="DECISION_ITEM_1"
                                                        id="userDecisionItem1"
                                                        :items="userDecision.decisionItem1List"
                                                        item-text="name"
                                                        item-value="code"
                                                        v-model="userDecision.selectedDecisionItem1Code"
                                                        @input="saveUserDecisionItem1"
                                                        @click.native="checkDecision1"
                                                        @change="changeDecision1"
                                                        :placeholder="text('api.scoring.select.decisionItem1.placeholder')"
                                                        append-icon="keyboard_arrow_down"
                                                        class="select-value"
                                                        :disabled="getIsAssessmentSealed"
                                                        content-class="user-decision-dropdown-options user-decision-item1-options"
                                                        v-bind:class="{ 'answer-value': userDecision.selectedDecisionItem1Code,
                                                                        'question-highlighted': shortcutNav.isKeyboardNav === true &&
                                                                                                shortcutNav.isPanelHighlight === false &&
                                                                                                shortcutNav.crtPanel === 'MY_DECISION' &&
                                                                                                shortcutNav.crtField === 'DECISION_ITEM_1'}">
                                                        <template slot="selection" slot-scope="data">
                                                            <span
                                                                v-bind:style="{color: (getDecisionItemColor(data.item) ? getDecisionItemColor(data.item) + ' !important' : '')}"><b>{{
                                                                    data.item.name
                                                                }}</b></span>
                                                        </template>
                                                        <template slot="item" slot-scope="data">
                                                        <span
                                                            :id="'USER_DI1_OPTION_' + data.item.code"
                                                            :style="{
                                                            color: (getDecisionItemColor(data.item) ? getDecisionItemColor(data.item) + ' !important' : ''),
                                                            fontWeight: (userDecision.selectedDecisionItem1Code === data.item.code ? 'bold' : '')
                                                        }">{{ data.item.name }}</span>
                                                        </template>
                                                    </v-select>
                                                </v-flex>

                                                <v-flex xs12 md8 lg9 class="no-padding-top">
                                                    <div v-if="selectedUserDecisionItem1Data"
                                                         class="user-decision-item2-text decision-item1">
                                                        <p v-html="selectedUserDecisionItem1Data.instructionText"></p>
                                                    </div>
                                                </v-flex>


                                            </v-layout>
                                            <v-layout row wrap v-if="userDecision.decisionItem2List">
                                                <v-flex xs12 md4 lg3 class="no-padding-top decision-row secondItem">
                                                    <!-- @TODO Add translation for placeholder -->

                                                    <div class="change-true">
                                                        <v-progress-circular v-if="newDecisionItem2"
                                                                             :value="100"
                                                                             class="color-primary"
                                                                             :rotate="-90"
                                                                             :width="1"
                                                                             :size="26"
                                                                             color="primary">
                                                            <radial-progress-svg
                                                                class="margin-top-xxs">
                                                            </radial-progress-svg>
                                                        </v-progress-circular>
                                                    </div>
                                                    <v-select
                                                        ref="DECISION_ITEM_2"
                                                        id="userDecisionItem2"
                                                        :items="userDecision.decisionItem2List"
                                                        item-text="name"
                                                        item-value="code"
                                                        v-model="userDecision.selectedDecisionItem2Code"
                                                        @input="saveUserDecisionItem2"
                                                        @click.native="checkDecision2"
                                                        @change="changeDecision2"
                                                        :placeholder="text('api.scoring.select.decisionItem2.placeholder')"
                                                        append-icon="keyboard_arrow_down"
                                                        class="select-value no-padding-top"
                                                        :disabled="getIsAssessmentSealed"
                                                        content-class="user-decision-dropdown-options user-decision-item2-options"
                                                        v-bind:class="{ 'answer-value': userDecision.selectedDecisionItem2Code,
                                                                        'question-highlighted': shortcutNav.isKeyboardNav === true &&
                                                                                                shortcutNav.isPanelHighlight === false &&
                                                                                                shortcutNav.crtPanel === 'MY_DECISION' &&
                                                                                                shortcutNav.crtField === 'DECISION_ITEM_2'}">
                                                        }">
                                                        <template slot="selection" slot-scope="data">
                                                            <span
                                                                :style="{color: (getDecisionItemColor(data.item) ? getDecisionItemColor(data.item) + ' !important' : '') }"
                                                                :class="{'empty-answer-option': userDecision.selectedDecisionItem2Code === null}"><b>{{
                                                                    data.item.name
                                                                }}</b></span>
                                                        </template>
                                                        <template slot="item" slot-scope="data">
                                                            <span
                                                                :id="'USER_DI2_OPTION_' + data.item.code"
                                                                :style="{
                                                                    color: (getDecisionItemColor(data.item) ? getDecisionItemColor(data.item) + ' !important' : ''),
                                                                    fontWeight: (userDecision.selectedDecisionItem2Code === data.item.code ? 'bold' : '')
                                                                }"
                                                            >{{ data.item.name }}</span>
                                                        </template>
                                                    </v-select>
                                                </v-flex>

                                                <v-flex xs12 md8 lg9 class="no-padding-top">
                                                    <div v-if="selectedUserDecisionItem2Data"
                                                         class="user-decision-item2-text decision-item2">
                                                    <span v-show="selectedUserDecisionItem2Data.target === true">
                                                         <WarningIcon
                                                             class="ambulance-scoring margin-right-xxs" width="28"
                                                             height="28" style="position: relative; bottom: 4px;">\
                                                         </WarningIcon>
                                                    </span>
                                                        <p v-html="selectedUserDecisionItem2Data.text"></p>
                                                    </div>
                                                </v-flex>
                                            </v-layout>

                                            <v-layout row wrap
                                                      v-for="(codeSystem, i, index) in userDecision.selectedCodeSystems"
                                                      :key="i">
                                                <v-flex xs12 class="selected-code-name-flex">
                                                    <h4 v-if="codeSystem.name !== 'undefined' &&
                                                              codeSystem.name !== null &&
                                                              codeSystem.name.length > 0"
                                                        class="name-code-system-scoring">
                                                        {{ codeSystem.name }}
                                                    </h4>
                                                </v-flex>

                                                <v-flex xs12 md4 lg3 class="padding-bottom-xs decision-row">
                                                    <!-- @TODO Add translation for placeholder -->
                                                    <div class="code-system-scoring">
                                                        <div class="change-true-code-name margin-top-xs">
                                                            <div class="change-true"
                                                                 v-for="(code, index) in codeSystem.articles"
                                                                 :key="index">

                                                                <div v-for="(arrayCode, index) in codeNamesArray "
                                                                     :key="index">
                                                                    <v-progress-circular
                                                                        v-if="(newUserCodeSystem || clickedInput !==i) && (code.code === arrayCode) && code.code === arrayCode"
                                                                        :value="100"
                                                                        class="color-primary"
                                                                        :rotate="-90"
                                                                        :width="1"
                                                                        :size="26"
                                                                        color="primary">
                                                                        <radial-progress-svg
                                                                            class="margin-top-xxs">
                                                                        </radial-progress-svg>
                                                                    </v-progress-circular>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <v-select
                                                            :disabled="getIsAssessmentSealed"
                                                            v-if="userDecision.selectedCodeSystemCodeMap !== null"
                                                            v-model="userDecision.selectedCodeSystemCodeMap[codeSystem.type]"
                                                            :items="codeSystem.articles"
                                                            :id="'aCODE_SYSTEM_'+i"
                                                            :ref="'CODE_SYSTEM_'+i"
                                                            :class="{'field-highlighted': shortcutNav.isKeyboardNav === true &&
                                                                                                shortcutNav.isPanelHighlight === false &&
                                                                                                shortcutNav.crtPanel === 'MY_DECISION' &&
                                                                                                shortcutNav.crtField === 'CODE_SYSTEM_'+i}"
                                                            :item-text="codeSystem.name"
                                                            class="select-value select-value-code-name margin-top-xs"
                                                            item-value="code"
                                                            @input="saveUserCodeSystem($event, codeSystem.type)"
                                                            append-icon="keyboard_arrow_down"
                                                            @change="changeCodeSystem($event)"
                                                            @click.native="checkCodeSystem($event, codeSystem.type)">
                                                            <template slot="selection" slot-scope="data">
                                                                <span
                                                                    v-bind:style="{color: (data.item.color ? data.item.color + ' !important' : '')}"><b>{{ data.item.code }} - {{
                                                                        data.item.name
                                                                    }}</b></span>
                                                            </template>
                                                            <template slot="item" slot-scope="data">
                                                                    <span
                                                                        :id="'USER_CODE_SYSTEM_' + i + '_OPTION_' + data.item.code"
                                                                        :style="{
                                                                            color: (data.item.color ? data.item.color + ' !important' : ''),
                                                                            fontWeight: (userDecision.selectedDecisionItem1Code === data.item.code ? 'bold' : '')
                                                                        }"
                                                                    >{{ data.item.code }} - {{ data.item.name }}</span>
                                                            </template>
                                                        </v-select>

                                                        <v-select
                                                            :disabled="getIsAssessmentSealed"
                                                            v-if="userDecision.selectedCodeSystemCodeMap === null"
                                                            :items="codeSystem.articles"
                                                            :item-text="codeSystem.name"
                                                            :id="'bCODE_SYSTEM_'+i"
                                                            :ref="'CODE_SYSTEM_'+i"
                                                            :class="{'question-highlighted': shortcutNav.isKeyboardNav === true &&
                                                                                                shortcutNav.isPanelHighlight === false &&
                                                                                                shortcutNav.crtPanel === 'MY_DECISION' &&
                                                                                                shortcutNav.crtField === 'CODE_SYSTEM_'+i}"
                                                            class="select-value select-value-code-name margin-top-xs"
                                                            item-value="code"
                                                            @input="saveUserCodeSystem($event, codeSystem.type)"
                                                            append-icon="keyboard_arrow_down"
                                                            @change="changeCodeSystem($event)"
                                                            @click.native="checkCodeSystem($event, codeSystem.type)">
                                                            <template slot="selection" slot-scope="data">
                                                                <span
                                                                    v-bind:style="{color: (data.item.color ? data.item.color + ' !important' : '')}"><b>{{ data.item.code }} - {{
                                                                        data.item.name
                                                                    }}</b></span>
                                                            </template>
                                                            <template slot="item" slot-scope="data">
                                                                <span
                                                                    :id="'USER_CODE_SYSTEM_' + i + '_OPTION_' + data.item.code"
                                                                    :style="{
                                                                        color: (data.item.color ? data.item.color + ' !important' : ''),
                                                                        fontWeight: (userDecision.selectedDecisionItem1Code === data.item.code ? 'bold' : '')
                                                                    }"
                                                                >{{ data.item.code }} - {{ data.item.name }}</span>
                                                            </template>
                                                        </v-select>
                                                    </div>
                                                </v-flex>
                                                <v-flex xs12 md8 lg9 class="no-padding-top">

                                                </v-flex>
                                            </v-layout>


                                            <v-layout row wrap>

                                                <v-flex xs12 sm6 md6 lg6 class="decision-row commentItem">
                                                    <div class="change-true">
                                                        <v-progress-circular v-if="newUserComment"
                                                                             :value="100"
                                                                             class="color-primary"
                                                                             color="primary"
                                                                             :rotate="-90"
                                                                             :width="1"
                                                                             :size="26"
                                                        >
                                                            <radial-progress-svg
                                                                class="margin-top-xxs">
                                                            </radial-progress-svg>
                                                        </v-progress-circular>
                                                    </div>
                                                    <v-text-field maxlength="1024"
                                                                  ref="USER_COMMENT"
                                                                  id="userDecisionComment"
                                                                  class="scoring-comment no-padding-top"
                                                                  :class="{'field-highlighted': shortcutNav.isKeyboardNav === true &&
                                                                                            shortcutNav.isPanelHighlight === false &&
                                                                                            shortcutNav.crtPanel === 'MY_DECISION' &&
                                                                                            shortcutNav.crtField === 'USER_COMMENT'}"
                                                                  :placeholder="text('api.scoring.comment.placeholder')"
                                                                  v-model="userDecision.comment"
                                                                  @focus="setTemporaryUserDecisionComment"
                                                                  @mousedown.stop
                                                                  @blur="saveUserDecisionComment"
                                                                  @change="changeComment"
                                                                  @click="navClickOnUserComment()"
                                                                  @click.native="checkComment"
                                                                  :readonly="getIsAssessmentSealed"
                                                                  textarea
                                                    >
                                                    </v-text-field>
                                                </v-flex>


                                                <v-flex xs12 sm6 md6 lg6 class="decision-row commentItem">

                                                    <v-text-field ref="PATIENT_COMMENT"
                                                                  id="comment"
                                                                  class="patient-comment no-padding-top"
                                                                  :class="{'field-highlighted': shortcutNav.isKeyboardNav === true &&
                                                                                            shortcutNav.isPanelHighlight === false &&
                                                                                            shortcutNav.crtPanel === 'MY_DECISION' &&
                                                                                            shortcutNav.crtField === 'PATIENT_COMMENT'}"
                                                                  :placeholder="text('api.patient.comment.placeholder')"
                                                                  v-model="patientProfileData.comment"
                                                                  @focus="setTemporaryPatientCommentValue"
                                                                  @mousedown.stop
                                                                  @blur="savePatientComment()"
                                                                  @click="navClickOnPatientComment()"
                                                                  :readonly="getIsAssessmentSealed"
                                                                  maxlength="1024"
                                                                  textarea
                                                    >
                                                    </v-text-field>

                                                    <div class="change-true change-true-right"
                                                         v-if="isPatientCommentSubmitted || isPatientCommentSaveInProgress">
                                                        <v-progress-circular v-if="isPatientCommentSubmitted"
                                                                             :value="100"
                                                                             class="color-primary"
                                                                             color="primary"
                                                                             :rotate="-90"
                                                                             :width="1"
                                                                             :size="26">
                                                            <radial-progress-svg
                                                                class="margin-top-xxs">
                                                            </radial-progress-svg>
                                                        </v-progress-circular>
                                                        <v-progress-circular v-else-if="isPatientCommentSaveInProgress"
                                                                             indeterminate
                                                                             class="color-gray"
                                                                             :width="1"
                                                                             :size="26">
                                                        </v-progress-circular>
                                                    </div>

                                                </v-flex>


                                            </v-layout>
                                        </v-container>
                                    </v-card-text>
                                </v-card>

                            </v-expansion-panel-content>
                        </v-expansion-panel>

                    </v-flex>
                </v-layout>
            </div>

        </v-container>

        <v-footer app class="elevation-bg-color border-top-invisible">
            <v-layout row wrap class="padding-left-xxl padding-right-xxl">

                <v-flex xs12 class="scoring-footer" text-xs-center>

                    <div class="footer-right-btns">
                        <v-btn flat @click="goToPreviousPage" id="btnGoToPrevPage" class="footer-btn home">
                            <arrow-left-icon/>
                            {{ text('api.button.back') }}
                        </v-btn>
                        <v-btn v-if="testTreeData" @click="getTestTree" id="btnTestTree" :disabled="!testTree"
                               class="footer-btn home footer-btn-next">
                            <span v-if="testTreeData.hasTestingTree">{{ text("api.pro.tests.getTestTree") }}</span>
                        </v-btn>
                        <v-btn v-if="testTreeData"
                               @click="showLabelPopup()"
                               id="close-upload-popup"
                               :disabled="testTree"
                               class="footer-btn home footer-btn-next"
                        >
                            <span>{{ text("api.pro.tests.addLabel") }}</span>
                        </v-btn>
                    </div>


                </v-flex>
            </v-layout>
        </v-footer>
        <label-popup></label-popup>
        <print-pdf-popup ref="printPdfPopupRef"></print-pdf-popup>
        <assessment-popup ref="assessmentPopupRef"></assessment-popup>
        <summary-popup ref="summaryPopupRef"></summary-popup>
        <div class="cookies-display">
            <detect-browser-cookie></detect-browser-cookie>
            <accept-cookie></accept-cookie>
        </div>
    </div>
</template>

<!-- ################################################################## -->
<script>
import {mapActions, mapGetters} from 'vuex';
import HeaderBar from '../shared/HeaderBar';
import TopBar from '../../../common/components/shared/TopBar';
import axios from 'axios';
import AssessmentAlerts from "../../../common/components/shared/AssessmentAlerts";
import PatientInfo from "../../../common/components/shared/PatientInfo";
import LabelPopup from '../../../common/components/shared/AddLabelTestPopup';
import PrintPdfPopup from './ConfirmPrintPdfPopup';
import AssessmentPopup from './SendAssessmentPopup';
import SummaryPopup from './SummaryPopup';
import RadialProgressSvg from "../../../common/components/svg/productList/radialProgress";
import AcceptCookie from '../../../professional/components/cookies/AcceptCookie';
import HeaderBarMedicalDevice from "../shared/HeaderBarMedicalDevice";
import DetectBrowserCookie from '../../../common/components/cookies/DetectBrowserCookie';
import ArrowLeftIcon from "../../../common/components/svg/shared/arrowLeftIcon";
import ExpandIcon from "../../../common/components/svg/shared/ExpandIcon";
import CollapseIcon from "../../../common/components/svg/shared/CollapseIcon";
import WarningIcon from "../../../common/components/svg/shared/warningIcon.vue";

const SCORING_PANELS = {
    NO_RECOMMENDATION: "NO_RECOMMENDATION",
    RECOMMENDATIONS: "RECOMMENDATIONS",
    RATIONALE: "RATIONALE",
    MEASURES: "MEASURES",
    MY_DECISION: "MY_DECISION"
};

const SCORING_FIELDS = {
    DECISION_ITEM_1: "DECISION_ITEM_1",
    DECISION_ITEM_2: "DECISION_ITEM_2",
    USER_COMMENT: "USER_COMMENT",
    PATIENT_COMMENT: "PATIENT_COMMENT"
};

export default {
    name: 'ScoringPage',

    components: {
        WarningIcon,
        CollapseIcon,
        ExpandIcon,
        ArrowLeftIcon,
        HeaderBar,
        TopBar,
        AssessmentAlerts,
        PatientInfo,
        LabelPopup,
        PrintPdfPopup,
        AssessmentPopup,
        SummaryPopup,
        RadialProgressSvg,
        AcceptCookie,
        HeaderBarMedicalDevice,
        DetectBrowserCookie
    },

    beforeCreate() {
        this.$store.commit('ScoringStore/resetStore');
        this.$store.commit('AssessmentAlertsStore/resetStore');
    },

    created() {
        this.$store.dispatch('ScoringStore/loadScoringData').then(res => {
            this.$store.commit('ScoringStore/setSummaryAssessmentId', res.data.data.ASSESSMENT.assessmentId);

            // Because we use Svg s for the expansion panels we need a way to switch between collapse and expand icons
            // We watch on the refs object to see if the isActive property is changed.
            // When its changed we set a reactive data accordingly
            this.$watch(
                () => {
                    return {
                        rationaleIsActive: this.$refs[SCORING_PANELS.RATIONALE] !== undefined ? this.$refs[SCORING_PANELS.RATIONALE].isActive : false,
                        measuresIsActive: this.$refs[SCORING_PANELS.MEASURES] !== undefined ? this.$refs[SCORING_PANELS.MEASURES].isActive : false,
                        recommendationsIsActive: this.$refs[SCORING_PANELS.RECOMMENDATIONS] !== undefined ? this.$refs[SCORING_PANELS.RECOMMENDATIONS].isActive : false,
                        myDecisionIsActive: this.$refs[SCORING_PANELS.MY_DECISION] !== undefined ? this.$refs[SCORING_PANELS.MY_DECISION].isActive : false,
                        noRecommendationsIsActive: this.$refs[SCORING_PANELS.NO_RECOMMENDATION] !== undefined ? this.$refs[SCORING_PANELS.NO_RECOMMENDATION].isActive : false,
                    }
                },
                (newValue) => {
                    this.isPanelActive[SCORING_PANELS.RATIONALE] = newValue.rationaleIsActive;
                    this.isPanelActive[SCORING_PANELS.MEASURES] = newValue.measuresIsActive;
                    this.isPanelActive[SCORING_PANELS.RECOMMENDATIONS] = newValue.recommendationsIsActive;
                    this.isPanelActive[SCORING_PANELS.MY_DECISION] = newValue.myDecisionIsActive;
                    this.isPanelActive[SCORING_PANELS.NO_RECOMMENDATION] = newValue.noRecommendationsIsActive;
                }
            )

            if (this.getUserData.embedded
                && this.getAssessmentEndFinishData !== null
                && typeof this.getAssessmentEndFinishData.buttonFinishUrl !== 'undefined' && this.getAssessmentEndFinishData.buttonFinishUrl !== null) {
                this.UtilitiesPlugin.createFormForData(this.getAssessmentEndFinishData.buttonFinishUrl, this.getAssessmentEndFinishData.buttonFinishParamMap, 'false');
            }

        });

        window.addEventListener('keydown', this.handleKeyDowns);
        window.addEventListener('keyup', this.handleKeyUps);
        window.addEventListener('click', this.handleClicks);
    },

    destroyed() {
        window.removeEventListener('keydown', this.handleKeyDowns);
        window.removeEventListener('keyup', this.handleKeyUps);
        window.removeEventListener('click', this.handleClicks);
    },

    mounted() {
        this.vSelectDI1 = this.$refs[SCORING_FIELDS.DECISION_ITEM_1];
        this.vSelectDI2 = this.$refs[SCORING_FIELDS.DECISION_ITEM_2];
        this.vTextFieldUserComment = this.$refs[SCORING_FIELDS.USER_COMMENT];
        this.vTextFieldPatientComment = this.$refs[SCORING_FIELDS.PATIENT_COMMENT];

        this.originalOnKeyDownDI1 = this.vSelectDI1.onKeyDown;
        this.vSelectDI1.onKeyDown = this.navCustomOnKeyDownDI1;

        this.originalToggleMenuDI1 = this.vSelectDI1.toggleMenu;
        this.vSelectDI1.toggleMenu = this.navCustomToggleMenuDI1;

        this.originalOnKeyDownDI2 = this.vSelectDI2.onKeyDown;
        this.vSelectDI2.onKeyDown = this.navCustomOnKeyDownDI2;

        this.originalToggleMenuDI2 = this.vSelectDI2.toggleMenu;
        this.vSelectDI2.toggleMenu = this.navCustomToggleMenuDI2;
    },

    data() {
        return {
            userDecisionTempComment: "",
            newDecisionItem1: false,
            newDecisionItem2: false,
            newUserCodeSystem: false,
            newUserComment: false,

            tempPatientComment: "",
            patientCommentSavedValue: "",
            isPatientCommentSaveInProgress: false,
            codeSystemKey: '',

            shortcutNav: {

                isKeyboardNav: false,

                isPanelHighlight: false,

                crtPanel: null,
                crtField: null,

                isFieldInEdit: false

            },

            isKeyDown: {},
            codeName: '',
            noSelectedCode: '',
            codeSystemName: '',
            codeNamesArray: [],
            codeSystemCheck: [],
            clickedInput: '',

            isPanelActive: {
                "RATIONALE": true,
                "RECOMMENDATIONS": true,
                "MEASURES": true,
                "MY_DECISION": true,
                "NO_RECOMMENDATION": true,
            }
        }
    },

    computed: {
        ...mapGetters({
            scoringData: 'ScoringStore/getScoringData',
            testTreeData: 'ScoringStore/getTestTreeData',
            testTree: 'TestStore/getTestTree',

            userDecision: 'ScoringStore/getUserDecision',
            selectedUserDecisionItem2Data: 'ScoringStore/getSelectedUserDecisionItem2Data',
            selectedUserDecisionItem1Data: 'ScoringStore/getSelectedUserDecisionItem1Data',
            getMustShowAssessmentList: 'SymptomsQuestionsStore/getMustShowAssessmentList',
            patientProfileData: 'AssessmentStartStore/getPatientProfileData',
            getIsAssessmentSealed: 'ScoringStore/getIsAssessmentSealed',
            getUserData: 'UserStore/getUserData',
            getMustShowEvaluationPage: 'TranslationStore/getMustShowEvaluationPage',
            getAppPropertyValue: 'TranslationStore/getAppPropertyValue',
            mustShowInfoPopup: 'MedicalDeviceInfoStore/getMustShowMedicalDeviceInfoPopup',
            getIsThemeDarkActive: 'TranslationStore/getIsThemeDarkActive',
            getDecisionItemColor: 'ThemeStore/getDecisionItemColor',
            getCurrentGuiThemeColor: 'ThemeStore/getCurrentGuiThemeColor',
            getAssessmentEndFinishData: 'ScoringStore/getAssessmentEndFinishData',
            getAppPropertyStudyAccess: 'TranslationStore/getAppPropertyStudyAccess',
        }),

        isPatientCommentSubmitted() {
            return (this.patientCommentSavedValue === this.patientProfileData.comment) ? true : false;
        },

        getCodeSystemLength() {
            if (this.userDecision != null) {
                return Object.keys(this.userDecision.selectedCodeSystems).length;
            }
            return 0;

        },


    },

    methods: {
        // Store actions.
        ...mapActions({
            showLabelPopup: 'TestStore/showAddLabelPopup',
            showSendAssessmentPopup: 'ScoringStore/showSendAssessmentPopup',
            showPrintPdfPopup: 'ScoringStore/showPrintPdfPopup',
            showSummaryPopup: 'ScoringStore/showSummaryPopup'
        }),

        goToPreviousPage() {

            if (this.scoringData.hasScoringData && this.getMustShowEvaluationPage) {
                this.$router.push('/evaluation');
            } else {
                if (!this.getMustShowAssessmentList) {
                    this.$router.push('/symptoms-questions');
                } else {
                    this.$router.push('/symptoms-list');
                }
            }

        },

        goToHomePage() {
            this.$store.dispatch("ProductListStore/loadProductListPageData").then(() => {
            });
        },
        getTestTree() {
            console.log("download file");
            axios({
                url: process.env.API_BASE_URL + '/test/deliverTestTree',
                method: 'POST',
                responseType: 'blob', // important
            }).then((response) => {
                const testName = response.headers["file-name-value"];
                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(new Blob([response.data]), testName); /* IE browser Solution*/
                } else {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', testName);
                    document.body.appendChild(link);
                    link.click();
                }
            });
        },
        hideTestPopup() {
            this.$store.commit('TestStore/setMustShowAddLabelPopup', false);
        },


        setTemporaryUserDecisionComment() {
            this.userDecisionTempComment = this.userDecision.comment;

            // Place cursor at the end of the patient comment text
            let userDecisionCommentId = document.getElementById("userDecisionComment");
            if (userDecisionCommentId != null) {

                let commentLength = userDecisionCommentId.value.length;
                userDecisionCommentId.selectionStart = commentLength;
                userDecisionCommentId.selectionEnd = commentLength;

                userDecisionCommentId.scrollTop = userDecisionCommentId.scrollHeight;
            }
        },
        isUserDecisionCommentChanged() {
            return (this.userDecisionTempComment === this.userDecision.comment) ? false : true;
        },

        saveUserDecisionItem1(value) {
            this.$store.dispatch("ScoringStore/submitUserDecisionItem1", {
                text: value
            });
            this.newDecisionItem1 = true;
        },
        saveUserDecisionItem2(value) {
            this.$store.dispatch("ScoringStore/submitUserDecisionItem2", {
                text: value,
            });
            this.newDecisionItem2 = true;
        },
        saveUserCodeSystem(event, i) {
            if (this.codeNamesArray.indexOf(event) === -1) {
                this.codeNamesArray.push(event);
            }
            this.codeSystemName = i;
            this.codeName = event;
            let that = this;
            that.newUserCodeSystem = true;
            this.$store.dispatch("ScoringStore/submitUserCodeSystemSelect", {
                // codeSystem: {
                codeSystem: i,
                codeArticle: event
                // }
            }).then((response) => {
                that.newUserCodeSystem = true;
            });

        },
        saveUserDecisionComment() {
            if (this.userDecisionTempComment !== null) {
                this.newUserComment = true;
            }
            if (this.isUserDecisionCommentChanged()) {
                this.$store.dispatch("ScoringStore/submitUserDecisionComment", {
                    text: this.userDecision.comment
                });
                this.newUserComment = true
            }
            this.shortcutNav.isFieldInEdit = false;
        },

        checkDecision1() {
            this.newDecisionItem1 = false;
            this.navClickOnDecision1();
        },
        checkDecision2() {
            this.newDecisionItem2 = false;
            this.navClickOnDecision2();
        },
        checkComment() {
            this.newUserComment = false;
        },
        changeDecision1() {
            this.newDecisionItem1 = true;
        },
        changeDecision2() {
            this.newDecisionItem2 = true;
        },
        changeComment() {
            this.newUserComment = true;
        },
        changeCodeSystem(event) {
            this.codeNamesArray.push(event);
            this.newUserCodeSystem = true;
        },
        checkCodeSystem(event, i) {
            this.clickedInput = i;
            let index = this.codeSystemCheck.findIndex(x => x == i);

            if (index === -1) {
                this.codeSystemCheck.push(i);
            } else {
                this.newUserCodeSystem = false;
            }
        },

        getIsPanelActive(panelReference) {
            return this.isPanelActive[panelReference];
        },

        // TODO To be removed
        onClickPanelHeader(event) {
            let panelReference = event.currentTarget.panelReference
            const panelRef = this.$refs[panelReference];

            this.$nextTick(() => {
                this.isPanelActive[panelReference] = panelRef.isActive;
            })

        },

        // TODO To be removed
        registerPanelHeaderClicks() {
            const recommendationsPanel = document.querySelector('#' + 'PANEL_' + SCORING_PANELS.RECOMMENDATIONS + ' .expansion-panel__header');
            if (recommendationsPanel) {
                recommendationsPanel.addEventListener('click', this.onClickPanelHeader, false);
                recommendationsPanel.panelReference = SCORING_PANELS.RECOMMENDATIONS;
            }
            const rationalePanel = document.querySelector('#' + 'PANEL_' + SCORING_PANELS.RATIONALE + ' .expansion-panel__header');
            if (rationalePanel) {
                rationalePanel.addEventListener('click', this.onClickPanelHeader, false);
                rationalePanel.panelReference = SCORING_PANELS.RATIONALE;
            }
            const myDecisionPanel = document.querySelector('#' + 'PANEL_' + SCORING_PANELS.MY_DECISION + ' .expansion-panel__header');
            if (myDecisionPanel) {
                myDecisionPanel.addEventListener('click', this.onClickPanelHeader, false);
                myDecisionPanel.panelReference = SCORING_PANELS.MY_DECISION;
            }
            const measuresPanel = document.querySelector('#' + 'PANEL_' + SCORING_PANELS.MEASURES + ' .expansion-panel__header');
            if (measuresPanel) {
                measuresPanel.addEventListener('click', this.onClickPanelHeader, false);
                measuresPanel.panelReference = SCORING_PANELS.MEASURES;
            }
            const noReccomandationPanel = document.querySelector('#' + 'PANEL_' + SCORING_PANELS.NO_RECOMMENDATION + ' .expansion-panel__header');
            if (noReccomandationPanel) {
                noReccomandationPanel.addEventListener('click', this.onClickPanelHeader, false);
                noReccomandationPanel.panelReference = SCORING_PANELS.NO_RECOMMENDATION;
            }
            const measuresSPanel = document.querySelector('#' + 'PANEL_' + SCORING_PANELS.MEASURES + 's' + ' .expansion-panel__header');
            if (measuresSPanel) {
                measuresSPanel.addEventListener('click', this.onClickPanelHeader, false);
                measuresSPanel.panelReference = SCORING_PANELS.MEASURES;
            }
        },

        setTemporaryPatientCommentValue() {
            this.tempPatientComment = this.patientProfileData.comment;

            // Place cursor at the end of the patient comment text
            let commentId = document.getElementById("comment");
            if (commentId != null) {

                let commentLength = commentId.value.length;
                commentId.selectionStart = commentLength;
                commentId.selectionEnd = commentLength;

                commentId.scrollTop = commentId.scrollHeight;
            }
        },

        isPatientCommentChanged() {
            return (this.tempPatientComment !== this.patientProfileData.comment) ? true : false;
        },

        savePatientComment() {
            if (this.isPatientCommentChanged()) {
                this.isPatientCommentSaveInProgress = true;
                this.$store.dispatch("AssessmentStartStore/submitPersistPatientProfileComment").then(() => {
                    this.patientCommentSavedValue = this.patientProfileData.comment;
                    this.isPatientCommentSaveInProgress = false;
                });
            }
            this.shortcutNav.isFieldInEdit = false;
        },

        startPrintPdf() {
            console.log("direct download");

            let requestParams = {
                assessmentToken: null,
                pdfTemplateType: "PRO",
                decisionItem1Label: null,
                decisionItem1Color: null,
                decisionItem2Label: null,
                decisionItem2Icon: null,
                decisionText: "",
                disclaimer1: "",
                disclaimer2: ""

            };

            if (typeof this.$route.query.assessmentId !== "undefined") {
                requestParams.assessmentToken = this.datasummary.overview.assessmentToken;
                requestParams.assessmentVersion = this.getAssessmentVersion;

            } else if (this.$route.query.assessment) {
                requestParams.assessmentToken = this.$route.query.assessment;
                requestParams.assessmentVersion = this.getAssessmentVersion;
            } else {
                requestParams.assessmentToken = null;
                requestParams.assessmentVersion = null;
            }

            let axiosRequest = axios.post(
                process.env.API_BASE_URL + '/assessment/deliverPDF',
                requestParams,
                {
                    responseType: 'arraybuffer',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/pdf'
                    }
                }
            );

            axiosRequest.then((response) => {

                const attachment_name = response.headers["attachement-file-name"];

                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(new Blob([response.data]), attachment_name); /* IE browser Solution*/
                } else {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    if (attachment_name == null || attachment_name == "") {
                        link.setAttribute('download', "assessment_case.pdf"); //or any other extension
                    } else {
                        link.setAttribute('download', attachment_name); //or any other extension
                    }

                    document.body.appendChild(link);
                    link.click();
                }
            });
            axiosRequest.catch((error) => {
                console.log(error);
            });
        },

        /*******************************
         ***   KEYBOARD NAVIGATION   ***
         ***      BEGIN CODE         ***
         *******************************/

        handleKeyDowns(event) {

            // DISABLE all keyUp functionalities when
            //          SendEmail popup is active  (mustShowSendAssessmentPopup === true)
            //          Summary popup is active    (mustShowSummaryPopup)
            //          PrintPdf  popup is active  (mustShowPrintPdfPopup === true)
            if ((this.$refs["assessmentPopupRef"] !== null && this.$refs["assessmentPopupRef"].mustShowSendAssessmentPopup === true) ||
                (this.$refs["summaryPopupRef"] !== null && this.$refs["summaryPopupRef"].mustShowSummaryPopup === true) ||
                (this.$refs["printPdfPopupRef"] !== null && this.$refs["printPdfPopupRef"].mustShowPrintPdfPopup === true)) {
                return;
            }

            let isAnyVSelectOpen = (this.vSelectDI1 !== null && this.vSelectDI1.menuIsActive === true)
                || (this.vSelectDI2 !== null && this.vSelectDI2.menuIsActive === true);

            for (let index = 0; index < this.getCodeSystemLength; index++) {
                let crtCodeSystemField = "CODE_SYSTEM_" + index;
                let vselectCodeSystem = this.$refs[crtCodeSystemField][0];
                if (vselectCodeSystem.menuIsActive === true) {
                    isAnyVSelectOpen = true;
                    break;
                }
            }

            switch (event.keyCode) {

                // Backspace
                case 8:
                    if (this.shortcutNav.isFieldInEdit === true && isAnyVSelectOpen === false) {
                        return;
                    }

                    event.preventDefault();
                    event.stopPropagation();
                    event.stopImmediatePropagation();
                    return false

                // Shift
                case 16:
                    // For Shift only, without other key combinations.
                    event.preventDefault();

                    if (this.mustShowInfoPopup === true) {
                        return;
                    }

                    if (isAnyVSelectOpen === true) {
                        if (this.vSelectDI1.menuIsActive === true) {
                            setTimeout(() => {
                                this.vSelectDI1.$el.blur();
                                this.vSelectDI1.hideMenu();
                            }, 75);
                        } else if (this.vSelectDI2.menuIsActive === true) {
                            setTimeout(() => {
                                this.vSelectDI2.$el.blur();
                                this.vSelectDI2.hideMenu();
                            }, 75);
                        }

                        for (let index = 0; index < this.getCodeSystemLength; index++) {
                            let crtCodeSystemField = "CODE_SYSTEM_" + index;
                            let vselectCodeSystem = this.$refs[crtCodeSystemField][0];
                            if (vselectCodeSystem.menuIsActive === true) {
                                setTimeout(() => {
                                    vselectCodeSystem.$el.blur();
                                    vselectCodeSystem.hideMenu();
                                }, 75);
                                this.shortcutNav.isFieldInEdit = false;
                            }
                        }
                    }

                    if (event.altKey === false && event.ctrlKey === false) {
                        // The first active panel should be MY_DECISION
                        if (this.shortcutNav.crtPanel === null) {
                            this.shortcutNav.crtPanel = SCORING_PANELS.MY_DECISION;
                        }

                        this.navScrollOnActivePanel();
                        this.navEnablePanelHighlight();
                    }
                    break;

                // Alt
                case 18:
                    event.preventDefault();
                    event.stopPropagation();
                    event.stopImmediatePropagation();
                    return false;

                // Escape
                case 27:
                    if (this.shortcutNav.isFieldInEdit === true) {

                        this.navDeactivateTextField();

                        // If there is a select open, close it
                        this.navBlurCurrentOpenSelect();
                        this.shortcutNav.isFieldInEdit = false;
                    }
                    break;

                // PageUp
                case 33:
                    event.preventDefault();
                    this.navBlurCurrentOpenSelect();

                    if (this.shortcutNav.isFieldInEdit === true || this.mustShowInfoPopup === true) {
                        return;
                    }

                    if (this.$refs["vLayoutScrollableRef"] != null) {
                        this.$refs["vLayoutScrollableRef"].scrollTop -= 10;
                    }

                    if (event.shiftKey === true && event.altKey === false && event.ctrlKey === false) {
                        // SHIFT+PageUp : Goto previous page
                        this.goToPreviousPage();
                    }

                    break;

                // PageDown
                case 34:
                    event.preventDefault();
                    this.navBlurCurrentOpenSelect();

                    if (this.shortcutNav.isFieldInEdit === true || this.mustShowInfoPopup === true) {
                        return;
                    }

                    if (this.$refs["vLayoutScrollableRef"] != null) {
                        this.$refs["vLayoutScrollableRef"].scrollTop += 10;
                    }
                    break;

                // Home
                case 36:
                    // Shift + Home
                    if (event.ctrlKey === false && event.altKey === false && event.shiftKey === true) {
                        // If we are editing the Patient comment or PID, do nothing in the Scoring Page
                        if (this.shortcutNav.isFieldInEdit === true) {
                            return;
                        }
                        //close the info popup if it is open
                        if (this.mustShowInfoPopup === true) {
                            return;
                        }
                        this.navGotoFirstPage();
                    }
                    break;

                // Using ARROW UP and ARROW DOWN will enter in the navigation mode
                case 38:
                case 40:

                    if (this.mustShowInfoPopup === true) {
                        return;
                    }

                    if (event.shiftKey === false && event.altKey === false && event.ctrlKey === false) {

                        // Security control: If we're editing a textarea, return
                        if (this.shortcutNav.crtPanel === SCORING_PANELS.MY_DECISION &&
                            (this.shortcutNav.crtField === SCORING_FIELDS.USER_COMMENT || this.shortcutNav.crtField === SCORING_FIELDS.PATIENT_COMMENT) &&
                            this.shortcutNav.isFieldInEdit === true) {
                            return;
                        }


                        // Entering in navigation mode
                        this.shortcutNav.isKeyboardNav = true;
                        this.shortcutNav.crtPanel = SCORING_PANELS.MY_DECISION;
                        this.shortcutNav.isPanelHighlight = false;

                        if (this.isAssessmentSealed !== true) {
                            this.navFocusPanelElement();
                        }

                        this.navScrollOnActivePanel();
                    }
                    break;

                // M
                case 77:
                    // ALT + M
                    if (event.shiftKey === false && event.altKey === true && event.ctrlKey === false) {
                        if (this.mustShowInfoPopup === true) {
                            this.$store.commit('MedicalDeviceInfoStore/setMustShowMedicalDeviceInfoPopup', false);

                            this.shortcutNav.isFieldInEdit = true;
                            this.shortcutNav.isPanelHighlight = false;
                        }
                        // focus on textarea comment
                        event.preventDefault();
                        this.navPatientCommentFocus();
                    }
                    break;

                // P
                case 80:
                    // ALT + P
                    if (event.shiftKey === false && event.altKey === true && event.ctrlKey === false) {
                        if (this.mustShowInfoPopup === true) {
                            this.$store.commit('MedicalDeviceInfoStore/setMustShowMedicalDeviceInfoPopup', false);
                        }
                        // ALT + p
                        event.preventDefault();
                        // If there is a select open, close it
                        this.navBlurCurrentOpenSelect();

                        this.showSummaryPopup();
                        break;
                    }

            }

            //Prevent repeated calls for certain keys
            if (this.isKeyDown[event.keyCode] === true) {
                return;
            }
            this.isKeyDown[event.keyCode] = true;

            // IN KEYBOARD NAVIGATION ONLY
            if (this.shortcutNav.isKeyboardNav === false) {
                return;
            }

            switch (event.keyCode) {

                // Tab
                case 9:
                    event.preventDefault();
                    event.stopPropagation();
                    event.stopImmediatePropagation();
                    return false;

                // ArrowLeft
                case 37:
                    if (this.shortcutNav.isFieldInEdit === false) {
                        event.preventDefault();
                    }

                    if (event.shiftKey === false && this.getIsAssessmentSealed === false) {
                        // We're in keyboard navigation, but not on MyDecisionPanel
                        if (this.shortcutNav.crtPanel !== SCORING_PANELS.MY_DECISION) {
                            this.shortcutNav.crtPanel = SCORING_PANELS.MY_DECISION;
                            this.navScrollOnActivePanel();
                        } else {
                            // Navigate between fields in MyDecisionPanel
                            if (this.shortcutNav.isFieldInEdit === true
                                && (this.shortcutNav.crtField === SCORING_FIELDS.USER_COMMENT || this.shortcutNav.crtField === SCORING_FIELDS.PATIENT_COMMENT)) {
                                // Keep the normal behaviour of navigation in textarea
                            } else {
                                this.navigateLeftRight();
                            }
                        }
                    }
                    break;

                // ArrowUp
                case 38:
                    if (this.shortcutNav.isFieldInEdit === false) {
                        event.preventDefault();
                    }

                    // SHIFT + UP
                    if (event.shiftKey === true && event.altKey === false && event.ctrlKey === false && this.shortcutNav.isFieldInEdit === false) {
                        this.navFocusPreviousPanel();
                        this.navScrollOnActivePanel();
                        break;
                    }
                    // UP
                    else if (event.shiftKey === false && this.getIsAssessmentSealed === false && isAnyVSelectOpen === false) {
                        // We're in keyboard navigation, but not on MyDecisionPanel
                        if (this.shortcutNav.crtPanel !== SCORING_PANELS.MY_DECISION) {
                            this.shortcutNav.crtPanel = SCORING_PANELS.MY_DECISION;
                            this.navScrollOnActivePanel();
                        } else {
                            // Navigate between fields in MyDecisionPanel
                            if (this.shortcutNav.isFieldInEdit === true
                                && (this.shortcutNav.crtField === SCORING_FIELDS.USER_COMMENT || this.shortcutNav.crtField === SCORING_FIELDS.PATIENT_COMMENT)) {
                                // Keep the normal behaviour of navigation in textarea
                            } else {
                                this.navigateUp();
                            }
                        }
                    }

                    // CTRL + UP
                    if (event.shiftKey === false && event.altKey === false && event.ctrlKey === true) {
                        if (this.shortcutNav.isFieldInEdit === true) {
                            this.navGotoFirstDIEntry();
                        } else {
                            this.navGotoFirstField();
                            this.navScrollOnActivePanel();
                        }
                    }

                    // CTRL + SHIFT + UP
                    if (event.shiftKey === true && event.altKey === false && event.ctrlKey === true) {
                        if (this.shortcutNav.isFieldInEdit === true) {
                            this.navDeactivateTextField();
                            this.shortcutNav.isFieldInEdit = false;
                        }
                        this.navGotoFirstPanel();
                        this.shortcutNav.isPanelHighlight = true;
                    }

                    break;

                // ArrowRight
                case 39:
                    if (this.shortcutNav.isFieldInEdit === false) {
                        event.preventDefault();
                    }

                    if (event.shiftKey === false && this.getIsAssessmentSealed === false) {
                        // We're in keyboard navigation, but not on MyDecisionPanel
                        if (this.shortcutNav.crtPanel !== SCORING_PANELS.MY_DECISION) {
                            this.shortcutNav.crtPanel = SCORING_PANELS.MY_DECISION;
                            this.navScrollOnActivePanel();
                        } else {
                            // Navigate between fields in MyDecisionPanel
                            if (this.shortcutNav.isFieldInEdit === true
                                && (this.shortcutNav.crtField === SCORING_FIELDS.USER_COMMENT || this.shortcutNav.crtField === SCORING_FIELDS.PATIENT_COMMENT)) {
                                // Keep the normal behaviour of navigation in textarea
                            } else {
                                this.navigateLeftRight();
                            }
                        }
                    }
                    break;

                // ArrowDown
                case 40:
                    if (this.shortcutNav.isFieldInEdit === false) {
                        event.preventDefault();
                    }

                    // SHIFT + DOWN
                    if (event.shiftKey === true && event.altKey === false && event.ctrlKey === false && this.shortcutNav.isFieldInEdit === false) {
                        this.navFocusNextPanel();
                        this.navScrollOnActivePanel();
                        break;
                    }

                    // DOWN
                    else if (event.shiftKey === false && this.getIsAssessmentSealed === false && isAnyVSelectOpen === false) {
                        // We're in keyboard navigation, but not on MyDecisionPanel
                        if (this.shortcutNav.crtPanel !== SCORING_PANELS.MY_DECISION) {
                            this.shortcutNav.crtPanel = SCORING_PANELS.MY_DECISION;
                            this.navScrollOnActivePanel();
                        } else {
                            // Navigate between fields in MyDecisionPanel
                            if (this.shortcutNav.isFieldInEdit === true
                                && (this.shortcutNav.crtField === SCORING_FIELDS.USER_COMMENT || this.shortcutNav.crtField === SCORING_FIELDS.PATIENT_COMMENT)) {
                                // Keep the normal behaviour of navigation in textarea
                            } else {
                                this.navigateDown();
                            }
                        }
                    }

                    // CTRL + DOWN
                    if (event.shiftKey === false && event.altKey === false && event.ctrlKey === true) {
                        if (this.shortcutNav.isFieldInEdit === true) {
                            this.navGotoLastDIEntry();
                        } else {
                            this.navGotoLastField();
                            this.navScrollOnActivePanel();
                        }
                    }

                    // CTRL + SHIFT + DOWN
                    if (event.shiftKey === true && event.altKey === false && event.ctrlKey === true) {
                        if (this.shortcutNav.isFieldInEdit === true) {
                            this.navDeactivateTextField();
                            this.shortcutNav.isFieldInEdit = false;
                        }
                        this.navGotoLastPanel();
                        this.shortcutNav.isPanelHighlight = true;
                    }
                    break;

                default:
                    // Do nothing, just ignore any unspecified keydowns.
                    break;

            }
        },

        handleKeyUps(event) {

            this.isKeyDown[event.keyCode] = false;

            // DISABLE all keyUp functionalities when
            //          SendEmail popup is active  (mustShowSendAssessmentPopup === true)
            //          Summary popup is active    (mustShowSummaryPopup)
            //          PrintPdf  popup is active  (mustShowPrintPdfPopup === true)
            if ((this.$refs["assessmentPopupRef"] !== null && this.$refs["assessmentPopupRef"].mustShowSendAssessmentPopup === true) ||
                (this.$refs["summaryPopupRef"] !== null && this.$refs["summaryPopupRef"].mustShowSummaryPopup === true) ||
                (this.$refs["printPdfPopupRef"] !== null && this.$refs["printPdfPopupRef"].mustShowPrintPdfPopup === true)) {
                return;
            }

            // Key down Shift will enable KeyboardNav. If not, the KeyUps will be ignored
            if (this.shortcutNav.isKeyboardNav === false) {
                switch (event.keyCode) {
                    // Enter
                    case 13:
                        event.preventDefault();

                        switch (this.shortcutNav.crtPanel) {
                            case SCORING_PANELS.MY_DECISION:
                                switch (this.shortcutNav.crtField) {
                                    case SCORING_FIELDS.USER_COMMENT:
                                        // CTRL + Enter on this textarea
                                        if (event.shiftKey === false && event.altKey === false && event.ctrlKey === true && this.shortcutNav.isFieldInEdit === true) {
                                            this.navDeactivateTextField();
                                            // We can have this case when we click on Patient Comment Field
                                            if (this.shortcutNav.isKeyboardNav === false) {
                                                this.shortcutNav.isKeyboardNav = true;
                                            }
                                            this.shortcutNav.isFieldInEdit = false;
                                        }
                                        break;
                                    case SCORING_FIELDS.PATIENT_COMMENT:
                                        // CTRL + Enter on this textarea
                                        if (event.shiftKey === false && event.altKey === false && event.ctrlKey === true && this.shortcutNav.isFieldInEdit === true) {
                                            this.navDeactivateTextField();
                                            // We can have this case when we click on Patient Comment Field
                                            if (this.shortcutNav.isKeyboardNav === false) {
                                                this.shortcutNav.isKeyboardNav = true;
                                            }
                                            this.shortcutNav.isFieldInEdit = false;
                                        }
                                        break;
                                }

                                break;

                        }
                        break;
                }
                return;
            }

            switch (event.keyCode) {

                // Tab
                case 9:
                    event.preventDefault();
                    event.stopPropagation();
                    event.stopImmediatePropagation();
                    return false;

                // Enter
                case 13:
                    event.preventDefault();

                    switch (this.shortcutNav.crtPanel) {

                        case SCORING_PANELS.MY_DECISION:
                            switch (this.shortcutNav.crtField) {

                                case SCORING_FIELDS.DECISION_ITEM_1:

                                    if (this.vSelectDI1.menuIsActive === false) {
                                        if (this.shortcutNav.isFieldInEdit === false) {
                                            this.vSelectDI1.$el.focus();
                                            this.vSelectDI1.showMenu();
                                        }
                                    } else {
                                        this.vSelectDI1.$el.focus();
                                        this.vSelectDI1.hideMenu();
                                    }

                                    this.shortcutNav.isFieldInEdit = this.vSelectDI1.menuIsActive;

                                    break;
                                case SCORING_FIELDS.DECISION_ITEM_2:

                                    if (this.vSelectDI2.menuIsActive === false) {
                                        if (this.shortcutNav.isFieldInEdit === false) {
                                            this.vSelectDI2.$el.focus();
                                            this.vSelectDI2.showMenu();
                                        }
                                    } else {
                                        this.vSelectDI2.$el.focus();
                                        this.vSelectDI2.hideMenu();
                                    }

                                    this.shortcutNav.isFieldInEdit = this.vSelectDI2.menuIsActive;

                                    break;

                                case SCORING_FIELDS.USER_COMMENT:
                                    // Enter
                                    if (event.shiftKey === false && event.altKey === false && event.ctrlKey === false && this.shortcutNav.isFieldInEdit === false) {
                                        this.navActivateFocusedTextField();
                                        this.shortcutNav.isFieldInEdit = true;
                                    }
                                    // CTRL + Enter on this textarea
                                    else if (event.shiftKey === false && event.altKey === false && event.ctrlKey === true && this.shortcutNav.isFieldInEdit === true) {
                                        this.navDeactivateTextField();
                                        this.shortcutNav.isFieldInEdit = false;
                                    }
                                    break;
                                case SCORING_FIELDS.PATIENT_COMMENT:
                                    // Enter
                                    if (event.shiftKey === false && event.altKey === false && event.ctrlKey === false && this.shortcutNav.isFieldInEdit === false) {
                                        this.navActivateFocusedTextField();
                                        this.shortcutNav.isFieldInEdit = true;
                                    }
                                    // CTRL + Enter on this textarea
                                    else if (event.shiftKey === false && event.altKey === false && event.ctrlKey === true && this.shortcutNav.isFieldInEdit === true) {
                                        this.navDeactivateTextField();
                                        this.shortcutNav.isFieldInEdit = false;
                                    }
                                    break;
                            }

                            break;

                    }

                    if (this.shortcutNav.crtPanel === SCORING_PANELS.MY_DECISION) {
                        for (let index = 0; index < this.getCodeSystemLength; index++) {
                            let crtCodeSystemField = "CODE_SYSTEM_" + index;

                            if (crtCodeSystemField === this.shortcutNav.crtField) {
                                if (event.shiftKey === false && event.altKey === false && event.ctrlKey === false) {
                                    let vselectCodeSystem = this.$refs[crtCodeSystemField][0];

                                    if (this.shortcutNav.isFieldInEdit === false) {
                                        if (this.shortcutNav.isFieldInEdit === false) {
                                            vselectCodeSystem.$el.focus();
                                            vselectCodeSystem.showMenu();
                                            this.shortcutNav.isFieldInEdit = true;
                                        }
                                    } else {
                                        vselectCodeSystem.$el.blur();
                                        vselectCodeSystem.hideMenu();
                                        this.shortcutNav.isFieldInEdit = false;
                                    }
                                }
                                break;
                            }
                        }
                    }

                    break;

                // Shift
                case 16:
                    this.navDisablePanelHighlight();
                    this.navFocusPanelElement();
                    if (this.shortcutNav.crtPanel === SCORING_PANELS.MY_DECISION
                        && (this.shortcutNav.crtField === SCORING_FIELDS.USER_COMMENT || this.shortcutNav.crtField === SCORING_FIELDS.PATIENT_COMMENT)) {
                        //do nothing
                    } else {
                        this.shortcutNav.isFieldInEdit = false;
                    }
                    this.navScrollOnActivePanel();
                    break;

                // Alt
                case 18:
                    event.preventDefault();
                    event.stopPropagation();
                    event.stopImmediatePropagation();
                    return false;

            }
        },

        handleClicks(event) {

            if (this.shortcutNav.isKeyboardNav === true && this.shortcutNav.isFieldInEdit === true) {
                this.navDeactivateTextField();
                this.navBlurCurrentOpenSelect();

                // If we're on a dropdown, isFieldInEdit will stay true

                let clickOnCodeSystem = false;
                for (let index = 0; index < this.getCodeSystemLength; index++) {
                    if (this.shortcutNav.crtField === "CODE_SYSTEM_" + index) {
                        clickOnCodeSystem = true;
                        break;
                    }
                }

                if (this.shortcutNav.crtPanel === SCORING_PANELS.MY_DECISION &&
                    (this.shortcutNav.crtField === SCORING_FIELDS.DECISION_ITEM_1 || this.shortcutNav.crtField === SCORING_FIELDS.DECISION_ITEM_2 || clickOnCodeSystem === true)) {
                    this.shortcutNav.isFieldInEdit = true;
                } else {
                    this.shortcutNav.isFieldInEdit = false;
                }
            }
            this.shortcutNav.isKeyboardNav = false;
        },

        navScrollOnActivePanel() {
            switch (this.shortcutNav.crtPanel) {

                case SCORING_PANELS.NO_RECOMMENDATION:
                    let noRecommendationsPanel = document.querySelector('#PANEL_NO_RECOMMENDATION');
                    let containerScrollableNoRec = document.querySelector('.scrolling-content-scoring');
                    containerScrollableNoRec.scrollTop = noRecommendationsPanel.offsetTop - 10;
                    break;

                case SCORING_PANELS.RECOMMENDATIONS:
                    let recommendationsPanel = document.querySelector('#PANEL_RECOMMENDATIONS');
                    let containerScrollableRec = document.querySelector('.scrolling-content-scoring');
                    containerScrollableRec.scrollTop = recommendationsPanel.offsetTop - 10;
                    break;

                case SCORING_PANELS.RATIONALE:
                    let rationalePanel = document.querySelector('#PANEL_RATIONALE');
                    let containerScrollableRat = document.querySelector('.scrolling-content-scoring');
                    containerScrollableRat.scrollTop = rationalePanel.offsetTop - 10;
                    break;

                case SCORING_PANELS.MEASURES:
                    let myDecisionPanelMeasures = document.querySelector('#PANEL_MEASURES');
                    if (myDecisionPanelMeasures === null) {
                        myDecisionPanelMeasures = document.querySelector('#PANEL_MEASURESs');
                    }
                    let containerScrollableMeasures = document.querySelector('.scrolling-content-scoring');
                    containerScrollableMeasures.scrollTop = myDecisionPanelMeasures.offsetTop - 10;
                    break;

                case SCORING_PANELS.MY_DECISION:
                    let myDecisionPanel = document.querySelector('#PANEL_MY_DECISION');
                    let containerScrollableMyDec = document.querySelector('.scrolling-content-scoring');
                    containerScrollableMyDec.scrollTop = myDecisionPanel.offsetTop - 10;
                    break;
            }
        },

        navScrollOnActiveField() {

            let containerScrollable = document.querySelector('.user-decision-container');
            if (containerScrollable === null) {
                return;
            }

            switch (this.shortcutNav.crtField) {
                case SCORING_FIELDS.DECISION_ITEM_1:
                    containerScrollable.scrollTop = this.vSelectDI1.$el.offsetTop - 10;
                    break;

                case SCORING_FIELDS.DECISION_ITEM_2:
                    containerScrollable.scrollTop = this.vSelectDI2.$el.offsetTop - 10;
                    break;

                case SCORING_FIELDS.USER_COMMENT:
                    containerScrollable.scrollTop = this.vTextFieldUserComment.$el.offsetTop - 10;
                    break;

                case SCORING_FIELDS.PATIENT_COMMENT:
                    containerScrollable.scrollTop = this.vTextFieldPatientComment.$el.offsetTop - 10;
                    break;

            }

        },

        navEnablePanelHighlight() {

            // When we click on a textarea and tap Shift for majuscule, do not enable panel highlight
            if (this.shortcutNav.isFieldInEdit === true &&
                (this.shortcutNav.crtField === SCORING_FIELDS.USER_COMMENT || this.shortcutNav.crtField === SCORING_FIELDS.PATIENT_COMMENT)) {
                return;
            }

            this.shortcutNav.isKeyboardNav = true;
            this.shortcutNav.isPanelHighlight = true;

        },

        navDisablePanelHighlight() {
            this.shortcutNav.isPanelHighlight = false;
        },

        navFocusPanelElement() {

            switch (this.shortcutNav.crtPanel) {

                case SCORING_PANELS.MY_DECISION:

                    // When My Decision panel is disabled, do not focus on panel elements
                    if (this.getIsAssessmentSealed === true) {
                        this.shortcutNav.crtField = null;
                        break;
                    }

                    if (this.shortcutNav.crtField === null) {
                        this.shortcutNav.crtField = SCORING_FIELDS.DECISION_ITEM_1;
                        this.vSelectDI1.$el.focus();
                    }
                    break;

            }
        },

        navigateLeftRight() {

            this.shortcutNav.isFieldInEdit = false;

            if (this.getIsAssessmentSealed === false) {

                switch (this.shortcutNav.crtField) {
                    case SCORING_FIELDS.USER_COMMENT:
                        this.shortcutNav.crtField = SCORING_FIELDS.PATIENT_COMMENT;
                        this.vTextFieldPatientComment.$el.focus();
                        break;
                    case SCORING_FIELDS.PATIENT_COMMENT:
                        this.shortcutNav.crtField = SCORING_FIELDS.USER_COMMENT;
                        this.vTextFieldUserComment.$el.focus();
                        break;
                }
            }
        },

        navigateDown() {

            this.shortcutNav.isFieldInEdit = false;
            let isNavigationDone = false;

            if (this.getIsAssessmentSealed === false) {
                switch (this.shortcutNav.crtField) {

                    case SCORING_FIELDS.DECISION_ITEM_1:
                        this.shortcutNav.crtField = SCORING_FIELDS.DECISION_ITEM_2;
                        this.navScrollOnActiveField();
                        isNavigationDone = true;
                        break;

                    case SCORING_FIELDS.DECISION_ITEM_2:
                        if (this.getCodeSystemLength === undefined || this.getCodeSystemLength === 0) {
                            this.shortcutNav.crtField = SCORING_FIELDS.USER_COMMENT;
                            this.navScrollOnActiveField();
                        } else {
                            this.shortcutNav.crtField = "CODE_SYSTEM_0";
                        }
                        isNavigationDone = true;
                        break;

                    case SCORING_FIELDS.USER_COMMENT:
                        if (this.$vuetify.breakpoint.smAndDown) {
                            // Patient comment is under user comment
                            this.shortcutNav.crtField = SCORING_FIELDS.PATIENT_COMMENT;
                            this.vTextFieldPatientComment.$el.focus();
                        } else {
                            this.shortcutNav.crtField = SCORING_FIELDS.DECISION_ITEM_1;
                        }
                        this.navScrollOnActiveField();
                        isNavigationDone = true;
                        break;

                    case SCORING_FIELDS.PATIENT_COMMENT:
                        // ONLY if patient comment is under user comment
                        if (this.$vuetify.breakpoint.xsOnly) {
                            this.shortcutNav.crtField = SCORING_FIELDS.DECISION_ITEM_1;
                            this.vSelectDI1.$el.focus();
                        }
                        this.navScrollOnActiveField();
                        isNavigationDone = true;
                        break;
                }

                if (isNavigationDone === false) {
                    for (let index = 0; index < this.getCodeSystemLength; index++) {
                        if (index === this.getCodeSystemLength - 1) {
                            this.shortcutNav.crtField = SCORING_FIELDS.USER_COMMENT;
                            this.vTextFieldUserComment.$el.focus();
                            this.navScrollOnActiveField();
                            break;
                        } else if (this.shortcutNav.crtField === "CODE_SYSTEM_" + index) {
                            let nextIndex = index + 1;
                            this.shortcutNav.crtField = "CODE_SYSTEM_" + nextIndex;
                            break;
                        }
                    }
                }
            }
        },

        navigateUp() {

            this.shortcutNav.isFieldInEdit = false;
            let isNavigationDone = false;

            if (this.getIsAssessmentSealed === false) {
                switch (this.shortcutNav.crtField) {

                    case SCORING_FIELDS.DECISION_ITEM_1:
                        // Patient comment is under user comment
                        if (this.$vuetify.breakpoint.smAndDown) {
                            this.shortcutNav.crtField = SCORING_FIELDS.PATIENT_COMMENT;
                            this.vTextFieldPatientComment.$el.focus();
                        } else {
                            this.shortcutNav.crtField = SCORING_FIELDS.USER_COMMENT;
                            this.vTextFieldUserComment.$el.focus();
                        }
                        isNavigationDone = true;
                        break;

                    case SCORING_FIELDS.DECISION_ITEM_2:
                        this.shortcutNav.crtField = SCORING_FIELDS.DECISION_ITEM_1;
                        isNavigationDone = true;
                        break;

                    case SCORING_FIELDS.USER_COMMENT:
                        if (this.getCodeSystemLength === undefined || this.getCodeSystemLength === 0) {
                            this.shortcutNav.crtField = SCORING_FIELDS.DECISION_ITEM_2;
                        } else {
                            let lastCodeSystemIndex = this.getCodeSystemLength - 1;
                            this.shortcutNav.crtField = "CODE_SYSTEM_" + lastCodeSystemIndex;
                        }
                        isNavigationDone = true;
                        break;

                    case SCORING_FIELDS.PATIENT_COMMENT:
                        // ONLY if patient comment is under user comment
                        if (this.$vuetify.breakpoint.xsOnly) {
                            this.shortcutNav.crtField = SCORING_FIELDS.USER_COMMENT;
                            this.vTextFieldUserComment.$el.focus();
                        }
                        isNavigationDone = true;
                        break;
                }

                if (isNavigationDone === false) {
                    for (let index = this.getCodeSystemLength; index >= 0; index--) {
                        if (index === 0) {
                            this.shortcutNav.crtField = SCORING_FIELDS.DECISION_ITEM_2;
                            this.vSelectDI2.$el.focus();
                            this.navScrollOnActiveField();
                            break;
                        } else if (this.shortcutNav.crtField === "CODE_SYSTEM_" + index) {
                            let previousIndex = index - 1;
                            this.shortcutNav.crtField = "CODE_SYSTEM_" + previousIndex;
                            break;
                        }
                    }
                }

                this.navScrollOnActiveField();
            }
        },

        navFocusNextPanel() {
            switch (this.shortcutNav.crtPanel) {
                case SCORING_PANELS.NO_RECOMMENDATION:
                    // MEASURES Panel is shown
                    if ((this.scoringData.recommendations && this.scoringData.hasScoringData && (this.scoringData.recommendations.recommendationsSections.length > 0))
                        || (this.scoringData.displayedCodeSystems !== null && Object.keys(this.scoringData.displayedCodeSystems).length > 0) && this.scoringData.hasScoringData === false) {
                        this.shortcutNav.crtPanel = SCORING_PANELS.MEASURES;
                    }
                    // RATIONALE Panel is shown
                    else if (this.scoringData.comments && this.scoringData.hasScoringData && this.scoringData.comments.commentTexts.length > 0) {
                        this.shortcutNav.crtPanel = SCORING_PANELS.RATIONALE;
                    }
                    // There is no other MY_DECISION
                    else {
                        this.shortcutNav.crtPanel = SCORING_PANELS.MY_DECISION
                    }
                    break;

                case SCORING_PANELS.RECOMMENDATIONS:
                    // RATIONALE Panel is shown
                    if (this.scoringData.comments && this.scoringData.hasScoringData && this.scoringData.comments.commentTexts.length > 0) {
                        this.shortcutNav.crtPanel = SCORING_PANELS.RATIONALE;
                    }
                    // MEASURES Panel is shown
                    else if (this.scoringData.recommendations && this.scoringData.hasScoringData && (this.scoringData.recommendations.recommendationsSections.length > 0)) {
                        this.shortcutNav.crtPanel = SCORING_PANELS.MEASURES;
                    }
                    // MY_DECISION Panel is always shown
                    else {
                        this.shortcutNav.crtPanel = SCORING_PANELS.MY_DECISION;
                    }
                    break;

                case SCORING_PANELS.RATIONALE:
                    // MEASURES Panel is shown
                    if (this.scoringData.recommendations && this.scoringData.hasScoringData && (this.scoringData.recommendations.recommendationsSections.length > 0)) {
                        this.shortcutNav.crtPanel = SCORING_PANELS.MEASURES;
                    }
                    // MY_DECISION Panel is always shown
                    else {
                        this.shortcutNav.crtPanel = SCORING_PANELS.MY_DECISION;
                    }
                    break;

                case SCORING_PANELS.MEASURES:
                    this.shortcutNav.crtPanel = SCORING_PANELS.MY_DECISION;
                    break;

                case SCORING_PANELS.MY_DECISION:
                    // NO_RECOMMENDATIONS shown
                    if (this.scoringData.hasScoringData === false) {
                        this.shortcutNav.crtPanel = SCORING_PANELS.NO_RECOMMENDATION;
                    }
                    // RECOMMENDATIONS Panel is shown
                    else if (this.scoringData.decisions && this.scoringData.hasScoringData) {
                        this.shortcutNav.crtPanel = SCORING_PANELS.RECOMMENDATIONS;
                    }
                    // RATIONALE Panel is shown
                    else if (this.scoringData.comments && this.scoringData.hasScoringData && this.scoringData.comments.commentTexts.length > 0) {
                        this.shortcutNav.crtPanel = SCORING_PANELS.RATIONALE;
                    }
                    // MEASURES Panel is shown
                    else if (this.scoringData.recommendations && this.scoringData.hasScoringData && (this.scoringData.recommendations.recommendationsSections.length > 0)) {
                        this.shortcutNav.crtPanel = SCORING_PANELS.MEASURES;
                    }
                    break;
            }
        },

        navFocusPreviousPanel() {
            switch (this.shortcutNav.crtPanel) {
                case SCORING_PANELS.NO_RECOMMENDATION:
                    // MY_DECISION Panel is always shown
                    this.shortcutNav.crtPanel = SCORING_PANELS.MY_DECISION
                    break;

                case SCORING_PANELS.RECOMMENDATIONS:
                    // MY_DECISION Panel is always shown
                    this.shortcutNav.crtPanel = SCORING_PANELS.MY_DECISION;
                    break;

                case SCORING_PANELS.RATIONALE:
                    // RECOMMENDATIONS Panel is shown
                    if (this.scoringData.decisions && this.scoringData.hasScoringData) {
                        this.shortcutNav.crtPanel = SCORING_PANELS.RECOMMENDATIONS;
                    }
                    // MY_DECISION Panel is always shown
                    else {
                        this.shortcutNav.crtPanel = SCORING_PANELS.MY_DECISION;
                    }
                    break;

                case SCORING_PANELS.MEASURES:
                    // RATIONALE Panel is shown
                    if (this.scoringData.comments && this.scoringData.hasScoringData && this.scoringData.comments.commentTexts.length > 0) {
                        this.shortcutNav.crtPanel = SCORING_PANELS.RATIONALE;
                    }
                    // RECOMMENDATIONS Panel is shown
                    else if (this.scoringData.hasScoringData && this.scoringData.decisions) {
                        this.shortcutNav.crtPanel = SCORING_PANELS.RECOMMENDATIONS;
                    }
                    // NO_RECOMMENDATIONS Panel is shown
                    else if (this.scoringData.hasScoringData === false) {
                        this.shortcutNav.crtPanel = SCORING_PANELS.NO_RECOMMENDATION;
                    }
                    // MY_DECISION Panel is always shown
                    else {
                        this.shortcutNav.crtPanel = SCORING_PANELS.MY_DECISION;
                    }
                    break;

                case SCORING_PANELS.MY_DECISION:
                    // MEASURES Panel is shown
                    if ((this.scoringData.recommendations && this.scoringData.hasScoringData && (this.scoringData.recommendations.recommendationsSections.length > 0))
                        || (this.scoringData.displayedCodeSystems !== null && Object.keys(this.scoringData.displayedCodeSystems).length > 0 && this.scoringData.hasScoringData === false)) {
                        this.shortcutNav.crtPanel = SCORING_PANELS.MEASURES;
                    }
                    // RATIONALE Panel is shown
                    else if (this.scoringData.comments && this.scoringData.hasScoringData && this.scoringData.comments.commentTexts.length > 0) {
                        this.shortcutNav.crtPanel = SCORING_PANELS.RATIONALE;
                    }
                    // RECOMMENDATIONS Panel is shown
                    else if (this.scoringData.hasScoringData && this.scoringData.decisions) {
                        this.shortcutNav.crtPanel = SCORING_PANELS.RECOMMENDATIONS;
                    }
                    // NO_RECOMMENDATIONS shown
                    else if (this.scoringData.hasScoringData === false) {
                        this.shortcutNav.crtPanel = SCORING_PANELS.NO_RECOMMENDATION;
                    }
                    break;
            }
        },

        navActivateFocusedTextField() {
            /**
             * Open (if field type is select) or activate (if field type is textarea) currently focused field.
             */
            if (this.shortcutNav.crtField === null) {
                return;
            } else if (this.shortcutNav.crtField === SCORING_FIELDS.USER_COMMENT && this.getIsAssessmentSealed === false) {
                this.$refs['USER_COMMENT'].$refs.input.focus();
            } else if (this.shortcutNav.crtField === SCORING_FIELDS.PATIENT_COMMENT && this.getIsAssessmentSealed === false) {
                this.$refs['PATIENT_COMMENT'].$refs.input.focus();
            }
        },

        navDeactivateTextField() {

            if (this.shortcutNav.crtPanel !== SCORING_PANELS.MY_DECISION || this.shortcutNav.crtField === null) {
                return;
            }

            switch (this.shortcutNav.crtField) {
                case SCORING_FIELDS.USER_COMMENT:
                    this.$refs['USER_COMMENT'].$refs.input.blur();
                    break;

                case SCORING_FIELDS.PATIENT_COMMENT:
                    this.$refs['PATIENT_COMMENT'].$refs.input.blur();
                    break;
            }

        },

        navCustomOnKeyDownDI1(e) {

            let useOriginal = true;

            // If Menu Closed AND enter, space, up, or down is pressed, DO NOT open menu
            if (!this.vSelectDI1.menuIsActive && [13, 32, 38, 40].includes(e.keyCode)) {
                useOriginal = false;
            }

            // If tab - DO NOTHING
            if (e.keyCode === 9) {
                useOriginal = false;
            }

            if (useOriginal === true) {
                return this.originalOnKeyDownDI1(e);
            }
        },

        navCustomToggleMenuDI1() {

            this.shortcutNav.isKeyboardNav = false;

            this.originalToggleMenuDI1();

        },

        navCustomOnKeyDownDI2(e) {

            // If Menu Closed AND enter, space, up, or down is pressed, DO NOT open menu
            if (!this.vSelectDI2.menuIsActive && [13, 32, 38, 40].includes(e.keyCode)) {
                return;
            }

            // If tab - DO NOTHING
            if (e.keyCode === 9) {
                return;
            }

            return this.originalOnKeyDownDI2(e);
        },

        navCustomToggleMenuDI2() {

            this.shortcutNav.isKeyboardNav = false;

            this.originalToggleMenuDI2();

        },

        navPatientCommentFocus() {

            // Activate navigation on MyDecisionPanel and PatientComment textarea
            if (this.getIsAssessmentSealed === false) {
                // Entering in navigation mode when My Decision panel is not readonly
                this.shortcutNav.isKeyboardNav = true;
            }

            // If there is an open select, close it
            this.navBlurCurrentOpenSelect();

            if (this.shortcutNav.crtPanel === SCORING_PANELS.MY_DECISION && this.shortcutNav.crtField === SCORING_FIELDS.USER_COMMENT) {
                this.navDeactivateTextField();
            }

            this.shortcutNav.crtPanel = SCORING_PANELS.MY_DECISION;
            this.shortcutNav.crtField = SCORING_FIELDS.PATIENT_COMMENT;
            this.navScrollOnActivePanel();

            /**
             * Focus on patient comment textarea. Add border with primary color, for 1 second.
             */
            let that = this;
            if (this.getIsAssessmentSealed === true) {
                setTimeout(function () {
                    that.shortcutNav.crtField = null
                }, 500);
            }

            // Patient comment Textarea will be directly editable if the panel is not disabled
            if (this.getIsAssessmentSealed === false) {
                this.shortcutNav.isFieldInEdit = true;
            }

            // Sanity assignment for having the same configuration
            this.shortcutNav.isPanelHighlight = false;

            // set a timeout to allow the focus to be set. 0 if the panel is already open, 250 if it is not
            setTimeout(() => {
                this.$refs['PATIENT_COMMENT'].$refs.input.focus();
            }, this.isPanelActive.MY_DECISION === false ? 250 : 0);

        },

        navManageClosedPanel(panelReference) {
            if (this.shortcutNav.isKeyboardNav === true) {
                if (this.shortcutNav.crtPanel === null) {
                    return true;
                } else if (this.shortcutNav.crtPanel === panelReference && this.shortcutNav.isPanelHighlight === false && this.navIsPanelClosed(panelReference) === true) {
                    return true;
                } else {
                    return this.navGetPanelValue(panelReference);
                }
            } else {
                return this.navGetPanelValue(panelReference);
            }
        },

        navIsPanelClosed(panelReference) {

            let panelValue = this.navGetPanelValue(panelReference);

            return (panelValue === 0 || panelValue === "undefined" || panelValue === false) ? true : false;
        },

        navGetPanelValue(panelReference) {
            let myDecisionPanelValue = true;
            if (typeof this.$refs[panelReference] !== 'undefined') {
                myDecisionPanelValue = this.$refs[panelReference].isActive;
            }
            return myDecisionPanelValue;
        },

        navClickOnDecision1() {
            this.shortcutNav.crtPanel = SCORING_PANELS.MY_DECISION;
            this.shortcutNav.crtField = SCORING_FIELDS.DECISION_ITEM_1;
            this.shortcutNav.isFieldInEdit = true;
            this.shortcutNav.isKeyboardNav = false;
            this.shortcutNav.isPanelHighlight = false;
        },

        navClickOnDecision2() {
            this.shortcutNav.crtPanel = SCORING_PANELS.MY_DECISION;
            this.shortcutNav.crtField = SCORING_FIELDS.DECISION_ITEM_2;
            this.shortcutNav.isFieldInEdit = true;
            this.shortcutNav.isKeyboardNav = false;
            this.shortcutNav.isPanelHighlight = false;
        },

        navClickOnPatientComment() {
            this.shortcutNav.crtPanel = SCORING_PANELS.MY_DECISION;
            this.shortcutNav.crtField = SCORING_FIELDS.PATIENT_COMMENT;
            this.shortcutNav.isKeyboardNav = false;
            this.shortcutNav.isFieldInEdit = true;
            this.shortcutNav.isPanelHighlight = false;
        },

        navClickOnUserComment() {
            this.shortcutNav.crtPanel = SCORING_PANELS.MY_DECISION;
            this.shortcutNav.crtField = SCORING_FIELDS.USER_COMMENT;
            this.shortcutNav.isKeyboardNav = false;
            this.shortcutNav.isFieldInEdit = true;
            this.shortcutNav.isPanelHighlight = false;
        },

        navGotoFirstPanel() {

            // NO_RECOMMENDATIONS
            if (this.scoringData.hasScoringData === false) {
                this.shortcutNav.crtPanel = SCORING_PANELS.NO_RECOMMENDATION;
            }
            // RECOMMENDATIONS
            else if (this.scoringData.decisions && this.scoringData.hasScoringData) {
                this.shortcutNav.crtPanel = SCORING_PANELS.RECOMMENDATIONS;
            }
            // RATIONALE
            else if (this.scoringData.comments && this.scoringData.hasScoringData) {
                this.shortcutNav.crtPanel = SCORING_PANELS.RATIONALE;
            }
            // MEASURES
            else if (this.scoringData.recommendations && this.scoringData.hasScoringData && (this.scoringData.recommendations.recommendationsSections.length > 0)) {
                this.shortcutNav.crtPanel = SCORING_PANELS.MEASURES;
            }
            this.navScrollOnActivePanel();
        },

        navGotoLastPanel() {
            this.shortcutNav.crtPanel = SCORING_PANELS.MY_DECISION;
            this.navScrollOnActivePanel();
        },

        navGotoFirstField() {

            // Activate navigation on MyDecisionPanel and DI1
            if (this.shortcutNav.isKeyboardNav === false) {
                // Entering in navigation mode
                this.shortcutNav.isKeyboardNav = true;
            }
            this.shortcutNav.crtPanel = SCORING_PANELS.MY_DECISION;
            this.shortcutNav.crtField = SCORING_FIELDS.DECISION_ITEM_1;
            this.navScrollOnActivePanel();

            /**
             * Focus on patient comment textarea. Add border with primary color, for 1 second.
             */
            let that = this;
            if (this.getIsAssessmentSealed === true) {
                setTimeout(function () {
                    that.shortcutNav.crtField = null
                }, 500);
            } else {
                this.vSelectDI1.$el.focus();
            }

        },

        navGotoLastField() {
            // Activate navigation on MyDecisionPanel and PatientComment textarea
            if (this.getIsAssessmentSealed === false) {
                // Entering in navigation mode when My Decision panel is not readonly
                this.shortcutNav.isKeyboardNav = true;
            }

            // If there is an open select, close it
            this.navBlurCurrentOpenSelect();

            this.shortcutNav.crtPanel = SCORING_PANELS.MY_DECISION;
            this.shortcutNav.crtField = SCORING_FIELDS.PATIENT_COMMENT;
            this.navScrollOnActivePanel();

            /**
             * Focus on patient comment textarea. Add border with primary color, for 1 second.
             */
            if (this.getIsAssessmentSealed === true) {
                let that = this;
                setTimeout(function () {
                    that.shortcutNav.crtField = null
                }, 500);
            }
            this.shortcutNav.isFieldInEdit = false;

        },

        navGotoLastDIEntry() {
            if (this.shortcutNav.crtPanel === SCORING_PANELS.MY_DECISION) {

                if (this.shortcutNav.crtField === SCORING_FIELDS.DECISION_ITEM_1) {

                    if (this.vSelectDI1 != null && this.vSelectDI1.menuIsActive) {

                        let entryList = this.navGetVSelectDIEntryList(SCORING_FIELDS.DECISION_ITEM_1);
                        if (entryList != null && entryList.length > 0) {
                            this.vSelectDI1.$refs.menu.listIndex = entryList.length - 1;
                        }
                    }
                } else if (this.shortcutNav.crtField === SCORING_FIELDS.DECISION_ITEM_2) {

                    if (this.vSelectDI2 != null && this.vSelectDI2.menuIsActive) {

                        let entryList = this.navGetVSelectDIEntryList(SCORING_FIELDS.DECISION_ITEM_2);
                        if (entryList != null && entryList.length > 0) {
                            this.vSelectDI2.$refs.menu.listIndex = entryList.length - 1;
                        }
                    }
                }
            }
        },

        navGotoFirstDIEntry() {

            if (this.shortcutNav.crtPanel === SCORING_PANELS.MY_DECISION) {

                if (this.shortcutNav.crtField === SCORING_FIELDS.DECISION_ITEM_1) {

                    if (this.vSelectDI1 != null && this.vSelectDI1.menuIsActive) {
                        this.vSelectDI1.$refs.menu.listIndex = 0;
                    }
                } else if (this.shortcutNav.crtField === SCORING_FIELDS.DECISION_ITEM_2) {

                    if (this.vSelectDI2 != null && this.vSelectDI2.menuIsActive) {
                        this.vSelectDI2.$refs.menu.listIndex = 0;
                    }
                }
            }
        },

        navGetVSelectDIEntryList(field) {

            this.vSelectDI = this.$refs[field];
            let entryList = null;

            if (this.vSelectDI.$refs != null
                && this.vSelectDI.$refs.menu != null
                && this.vSelectDI.$refs.menu.$children != null
                && this.vSelectDI.$refs.menu.$children[0] != null
                && this.vSelectDI.$refs.menu.$children[0].$children != null
                && this.vSelectDI.$refs.menu.$children[0].$children[0] != null
                && this.vSelectDI.$refs.menu.$children[0].$children[0].$children != null) {

                entryList = this.vSelectDI.$refs.menu.$children[0].$children[0].$children;
            }

            return entryList;
        },

        navBlurCurrentOpenSelect() {
            if (this.shortcutNav.crtPanel === SCORING_PANELS.MY_DECISION) {
                switch (this.shortcutNav.crtField) {
                    case SCORING_FIELDS.DECISION_ITEM_1:
                        this.vSelectDI1.hideMenu();
                        this.vSelectDI1.$el.blur();
                        this.shortcutNav.isFieldInEdit = false;
                        break;

                    case SCORING_FIELDS.DECISION_ITEM_2:
                        this.vSelectDI2.hideMenu();
                        this.vSelectDI2.$el.blur();
                        this.shortcutNav.isFieldInEdit = false;
                        break;
                }
            }

            for (let index = 0; index < this.getCodeSystemLength; index++) {
                let crtCodeSystemField = "CODE_SYSTEM_" + index;

                if (this.shortcutNav.crtField === crtCodeSystemField) {
                    let vselectCodeSystem = this.$refs[crtCodeSystemField][0];
                    vselectCodeSystem.hideMenu();
                    vselectCodeSystem.$el.blur();
                    this.shortcutNav.isFieldInEdit = false;
                    break;
                }
            }
        },

        navGotoFirstPage() {
            if (!this.getMustShowAssessmentList) {
                this.$router.push('/assessment-start');
            } else {
                this.$router.push('/assessment-start-list');
            }

        }

        /*******************************
         ***   KEYBOARD NAVIGATION   ***
         ***        END CODE         ***
         *******************************/

    },

}

</script>

<!-- ################################################################## -->

<style lang="scss" scoped>

.layout.layout-scoring-page {
    margin-bottom: 5px !important;
}

/*img.ambulance-scoring.scoring-page {
    position: relative;
    top: 6px;
    left: -8px;
}*/

.card > .card__text {
    padding-left: 5px;
}


.footer-btn.scoring {


    &:first-of-type {
        margin-left: 0 !important;
    }
}


.pdf-btn .scoring {
    color: $color-body-text;
}


.warning-symptoms {

    span, ul li {
        font-weight: $font-weight-regular;
    }

    ul li {
        list-style-type: disc !important;
        margin-left: 15px;
    }

}

.scoring-page-container {
    .selected-code-name-flex {
        padding: 0 12px !important;

        .name-code-system-scoring {
            position: relative;
            margin-left: 35px;
            top: 30px;
        }
    }

}

</style>



// WEBPACK FOOTER //
// src/professional/components/scoring/ScoringPage.vue